export const HbrHandsUpMaleIcon=({width,height,handleClick})=>{
    return(
      <svg
        onClick={handleClick}
        viewBox="0 0 32 32"
        width={width}
        height={height}>
        <g fill="none">
          <path
            fill="url(#f1234id0)"
            d="M3.605 9.01c-.125-1.921-.282-2.958-.328-3.64c-.036-.512.023-1.067.71-1.192c.598-.074.883.452.907.66c-.003-.2 0-.679 0-.804c0-.211.008-.977.86-.977c.6 0 .816.588.8.864c.01-.102.023-.414.035-.707c.019-.434.252-.99.945-.977c.598.04.793.613.766.977L8.183 5.08c.023-.188.102-.665.277-1.34s.702-.72.957-.684c.326.047.88.361.649 1.274c-.275 1.156-.463 2.644-.528 3.285c.32-.131.605-.429.957-.796l.016-.017c.36-.375.934-.332 1.172-.105c.363.234.562.937.16 1.34c-.463.425-2.129 2.405-2.957 3.394c-.23.292-.997.875-2.234.875c-2.204-.093-2.942-1.676-3.047-3.297"
          ></path>
          <path
            fill="url(#f1234id1)"
            d="M3.605 9.01c-.125-1.921-.282-2.958-.328-3.64c-.036-.512.023-1.067.71-1.192c.598-.074.883.452.907.66c-.003-.2 0-.679 0-.804c0-.211.008-.977.86-.977c.6 0 .816.588.8.864c.01-.102.023-.414.035-.707c.019-.434.252-.99.945-.977c.598.04.793.613.766.977L8.183 5.08c.023-.188.102-.665.277-1.34s.702-.72.957-.684c.326.047.88.361.649 1.274c-.275 1.156-.463 2.644-.528 3.285c.32-.131.605-.429.957-.796l.016-.017c.36-.375.934-.332 1.172-.105c.363.234.562.937.16 1.34c-.463.425-2.129 2.405-2.957 3.394c-.23.292-.997.875-2.234.875c-2.204-.093-2.942-1.676-3.047-3.297"
          ></path>
          <path
            fill="url(#f1234id13)"
            d="M3.605 9.01c-.125-1.921-.282-2.958-.328-3.64c-.036-.512.023-1.067.71-1.192c.598-.074.883.452.907.66c-.003-.2 0-.679 0-.804c0-.211.008-.977.86-.977c.6 0 .816.588.8.864c.01-.102.023-.414.035-.707c.019-.434.252-.99.945-.977c.598.04.793.613.766.977L8.183 5.08c.023-.188.102-.665.277-1.34s.702-.72.957-.684c.326.047.88.361.649 1.274c-.275 1.156-.463 2.644-.528 3.285c.32-.131.605-.429.957-.796l.016-.017c.36-.375.934-.332 1.172-.105c.363.234.562.937.16 1.34c-.463.425-2.129 2.405-2.957 3.394c-.23.292-.997.875-2.234.875c-2.204-.093-2.942-1.676-3.047-3.297"
          ></path>
          <path
            fill="url(#f1234id2)"
            d="M3.605 9.01c-.125-1.921-.282-2.958-.328-3.64c-.036-.512.023-1.067.71-1.192c.598-.074.883.452.907.66c-.003-.2 0-.679 0-.804c0-.211.008-.977.86-.977c.6 0 .816.588.8.864c.01-.102.023-.414.035-.707c.019-.434.252-.99.945-.977c.598.04.793.613.766.977L8.183 5.08c.023-.188.102-.665.277-1.34s.702-.72.957-.684c.326.047.88.361.649 1.274c-.275 1.156-.463 2.644-.528 3.285c.32-.131.605-.429.957-.796l.016-.017c.36-.375.934-.332 1.172-.105c.363.234.562.937.16 1.34c-.463.425-2.129 2.405-2.957 3.394c-.23.292-.997.875-2.234.875c-2.204-.093-2.942-1.676-3.047-3.297"
          ></path>
          <path
            fill="url(#f1234id3)"
            d="M3.605 9.01c-.125-1.921-.282-2.958-.328-3.64c-.036-.512.023-1.067.71-1.192c.598-.074.883.452.907.66c-.003-.2 0-.679 0-.804c0-.211.008-.977.86-.977c.6 0 .816.588.8.864c.01-.102.023-.414.035-.707c.019-.434.252-.99.945-.977c.598.04.793.613.766.977L8.183 5.08c.023-.188.102-.665.277-1.34s.702-.72.957-.684c.326.047.88.361.649 1.274c-.275 1.156-.463 2.644-.528 3.285c.32-.131.605-.429.957-.796l.016-.017c.36-.375.934-.332 1.172-.105c.363.234.562.937.16 1.34c-.463.425-2.129 2.405-2.957 3.394c-.23.292-.997.875-2.234.875c-2.204-.093-2.942-1.676-3.047-3.297"
          ></path>
          <path
            fill="url(#f1234id4)"
            d="M3.605 9.01c-.125-1.921-.282-2.958-.328-3.64c-.036-.512.023-1.067.71-1.192c.598-.074.883.452.907.66c-.003-.2 0-.679 0-.804c0-.211.008-.977.86-.977c.6 0 .816.588.8.864c.01-.102.023-.414.035-.707c.019-.434.252-.99.945-.977c.598.04.793.613.766.977L8.183 5.08c.023-.188.102-.665.277-1.34s.702-.72.957-.684c.326.047.88.361.649 1.274c-.275 1.156-.463 2.644-.528 3.285c.32-.131.605-.429.957-.796l.016-.017c.36-.375.934-.332 1.172-.105c.363.234.562.937.16 1.34c-.463.425-2.129 2.405-2.957 3.394c-.23.292-.997.875-2.234.875c-2.204-.093-2.942-1.676-3.047-3.297"
          ></path>
          <path
            fill="url(#f1234id5)"
            d="M3.605 9.01c-.125-1.921-.282-2.958-.328-3.64c-.036-.512.023-1.067.71-1.192c.598-.074.883.452.907.66c-.003-.2 0-.679 0-.804c0-.211.008-.977.86-.977c.6 0 .816.588.8.864c.01-.102.023-.414.035-.707c.019-.434.252-.99.945-.977c.598.04.793.613.766.977L8.183 5.08c.023-.188.102-.665.277-1.34s.702-.72.957-.684c.326.047.88.361.649 1.274c-.275 1.156-.463 2.644-.528 3.285c.32-.131.605-.429.957-.796l.016-.017c.36-.375.934-.332 1.172-.105c.363.234.562.937.16 1.34c-.463.425-2.129 2.405-2.957 3.394c-.23.292-.997.875-2.234.875c-2.204-.093-2.942-1.676-3.047-3.297"
          ></path>
          <path
            fill="url(#f1234id6)"
            d="M3.605 9.01c-.125-1.921-.282-2.958-.328-3.64c-.036-.512.023-1.067.71-1.192c.598-.074.883.452.907.66c-.003-.2 0-.679 0-.804c0-.211.008-.977.86-.977c.6 0 .816.588.8.864c.01-.102.023-.414.035-.707c.019-.434.252-.99.945-.977c.598.04.793.613.766.977L8.183 5.08c.023-.188.102-.665.277-1.34s.702-.72.957-.684c.326.047.88.361.649 1.274c-.275 1.156-.463 2.644-.528 3.285c.32-.131.605-.429.957-.796l.016-.017c.36-.375.934-.332 1.172-.105c.363.234.562.937.16 1.34c-.463.425-2.129 2.405-2.957 3.394c-.23.292-.997.875-2.234.875c-2.204-.093-2.942-1.676-3.047-3.297"
          ></path>
          <path
            fill="url(#f1234id7)"
            d="M3.605 9.01c-.125-1.921-.282-2.958-.328-3.64c-.036-.512.023-1.067.71-1.192c.598-.074.883.452.907.66c-.003-.2 0-.679 0-.804c0-.211.008-.977.86-.977c.6 0 .816.588.8.864c.01-.102.023-.414.035-.707c.019-.434.252-.99.945-.977c.598.04.793.613.766.977L8.183 5.08c.023-.188.102-.665.277-1.34s.702-.72.957-.684c.326.047.88.361.649 1.274c-.275 1.156-.463 2.644-.528 3.285c.32-.131.605-.429.957-.796l.016-.017c.36-.375.934-.332 1.172-.105c.363.234.562.937.16 1.34c-.463.425-2.129 2.405-2.957 3.394c-.23.292-.997.875-2.234.875c-2.204-.093-2.942-1.676-3.047-3.297"
          ></path>
          <path
            fill="url(#f1234id8)"
            d="M3.605 9.01c-.125-1.921-.282-2.958-.328-3.64c-.036-.512.023-1.067.71-1.192c.598-.074.883.452.907.66c-.003-.2 0-.679 0-.804c0-.211.008-.977.86-.977c.6 0 .816.588.8.864c.01-.102.023-.414.035-.707c.019-.434.252-.99.945-.977c.598.04.793.613.766.977L8.183 5.08c.023-.188.102-.665.277-1.34s.702-.72.957-.684c.326.047.88.361.649 1.274c-.275 1.156-.463 2.644-.528 3.285c.32-.131.605-.429.957-.796l.016-.017c.36-.375.934-.332 1.172-.105c.363.234.562.937.16 1.34c-.463.425-2.129 2.405-2.957 3.394c-.23.292-.997.875-2.234.875c-2.204-.093-2.942-1.676-3.047-3.297"
          ></path>
          <path
            fill="url(#f1234id9)"
            d="M3.605 9.01c-.125-1.921-.282-2.958-.328-3.64c-.036-.512.023-1.067.71-1.192c.598-.074.883.452.907.66c-.003-.2 0-.679 0-.804c0-.211.008-.977.86-.977c.6 0 .816.588.8.864c.01-.102.023-.414.035-.707c.019-.434.252-.99.945-.977c.598.04.793.613.766.977L8.183 5.08c.023-.188.102-.665.277-1.34s.702-.72.957-.684c.326.047.88.361.649 1.274c-.275 1.156-.463 2.644-.528 3.285c.32-.131.605-.429.957-.796l.016-.017c.36-.375.934-.332 1.172-.105c.363.234.562.937.16 1.34c-.463.425-2.129 2.405-2.957 3.394c-.23.292-.997.875-2.234.875c-2.204-.093-2.942-1.676-3.047-3.297"
          ></path>
          <path
            fill="url(#f1234id14)"
            d="M4.675 11.94c0-.11.09-.2.2-.2h3.81a.2.2 0 0 1 .2.2v1.714h-4.21z"
          ></path>
          <path
            fill="url(#f1234ida)"
            d="M4.675 11.94c0-.11.09-.2.2-.2h3.81a.2.2 0 0 1 .2.2v1.714h-4.21z"
          ></path>
          <path
            fill="url(#f1234id15)"
            d="M4.675 11.94c0-.11.09-.2.2-.2h3.81a.2.2 0 0 1 .2.2v1.714h-4.21z"
          ></path>
          <path
            fill="url(#f1234id16)"
            d="M20.29 20.763h.97c2.49 0 7.471 3.5 7.471 9H10.798v-3.5a.67.67 0 0 0-.414-.625l-3.073-1.375c-2.49-1-3.487-3.5-3.487-5.198v-5.287c0-.564.424-1.015.932-1.015H8.87c.518 0 .932.461.932 1.015v3.985c0 1.302.996 1.5.996 1.5l5.978 1.5z"
          ></path>
          <path
            fill="url(#f1234idb)"
            d="M20.29 20.763h.97c2.49 0 7.471 3.5 7.471 9H10.798v-3.5a.67.67 0 0 0-.414-.625l-3.073-1.375c-2.49-1-3.487-3.5-3.487-5.198v-5.287c0-.564.424-1.015.932-1.015H8.87c.518 0 .932.461.932 1.015v3.985c0 1.302.996 1.5.996 1.5l5.978 1.5z"
          ></path>
          <path
            fill="url(#f1234idc)"
            d="M20.29 20.763h.97c2.49 0 7.471 3.5 7.471 9H10.798v-3.5a.67.67 0 0 0-.414-.625l-3.073-1.375c-2.49-1-3.487-3.5-3.487-5.198v-5.287c0-.564.424-1.015.932-1.015H8.87c.518 0 .932.461.932 1.015v3.985c0 1.302.996 1.5.996 1.5l5.978 1.5z"
          ></path>
          <path
            fill="url(#f1234id17)"
            d="m18.683 20.873l-7.874 5.245a.66.66 0 0 0-.4-.48l-3.085-1.375c-2.5-1-3.5-3.5-3.5-5.198v-5.287c0-.564.426-1.015.936-1.015h4.13c.519 0 .934.461.934 1.015v3.985c0 1.302 1 1.5 1 1.5l6 1.5z"
          ></path>
          <path
            fill="url(#f1234idd)"
            d="m18.683 20.873l-7.874 5.245a.66.66 0 0 0-.4-.48l-3.085-1.375c-2.5-1-3.5-3.5-3.5-5.198v-5.287c0-.564.426-1.015.936-1.015h4.13c.519 0 .934.461.934 1.015v3.985c0 1.302 1 1.5 1 1.5l6 1.5z"
          ></path>
          <path
            fill="url(#f1234ide)"
            d="m18.683 20.873l-7.874 5.245a.66.66 0 0 0-.4-.48l-3.085-1.375c-2.5-1-3.5-3.5-3.5-5.198v-5.287c0-.564.426-1.015.936-1.015h4.13c.519 0 .934.461.934 1.015v3.985c0 1.302 1 1.5 1 1.5l6 1.5z"
          ></path>
          <path
            fill="url(#f1234idf)"
            d="m18.683 20.873l-7.874 5.245a.66.66 0 0 0-.4-.48l-3.085-1.375c-2.5-1-3.5-3.5-3.5-5.198v-5.287c0-.564.426-1.015.936-1.015h4.13c.519 0 .934.461.934 1.015v3.985c0 1.302 1 1.5 1 1.5l6 1.5z"
          ></path>
          <path
            fill="url(#f1234id18)"
            d="m18.683 20.873l-7.874 5.245a.66.66 0 0 0-.4-.48l-3.085-1.375c-2.5-1-3.5-3.5-3.5-5.198v-5.287c0-.564.426-1.015.936-1.015h4.13c.519 0 .934.461.934 1.015v3.985c0 1.302 1 1.5 1 1.5l6 1.5z"
          ></path>
          <path
            fill="url(#f1234id19)"
            d="m18.683 20.873l-7.874 5.245a.66.66 0 0 0-.4-.48l-3.085-1.375c-2.5-1-3.5-3.5-3.5-5.198v-5.287c0-.564.426-1.015.936-1.015h4.13c.519 0 .934.461.934 1.015v3.985c0 1.302 1 1.5 1 1.5l6 1.5z"
          ></path>
          <path
            fill="url(#f1234id1a)"
            d="M19.325 23.869c-1.268 0-2.297-.985-2.297-2.2v-2.6c0-1.215 1.029-2.2 2.297-2.2c1.267 0 2.296.985 2.296 2.2v2.6c0 1.215-1.029 2.2-2.296 2.2"
          ></path>
          <path
            fill="url(#f1234idg)"
            d="M19.325 23.869c-1.268 0-2.297-.985-2.297-2.2v-2.6c0-1.215 1.029-2.2 2.297-2.2c1.267 0 2.296.985 2.296 2.2v2.6c0 1.215-1.029 2.2-2.296 2.2"
          ></path>
          <g filter="url(#f1234id1q)">
            <path
              stroke="url(#f1234id1b)"
              d="M7.667 13.691v5.172a2 2 0 0 0 1.38 1.901l4.182 1.363"
            ></path>
          </g>
          <g filter="url(#f1234id1r)">
            <path
              stroke="url(#f1234id1c)"
              strokeLinecap="round"
              strokeWidth=".075"
              d="m4.918 4.95l.132 1.42"
            ></path>
          </g>
          <g filter="url(#f1234id1s)">
            <path
              stroke="url(#f1234id1d)"
              strokeLinecap="round"
              strokeWidth=".075"
              d="m6.55 4.036l-.093 2.063"
            ></path>
          </g>
          <g filter="url(#f1234id1t)">
            <path
              stroke="url(#f1234id1e)"
              strokeLinecap="round"
              strokeWidth=".075"
              d="m8.16 5.169l-.156 1.203"
            ></path>
          </g>
          <circle
            cx="13.652"
            cy="13.975"
            r="1.991"
            fill="url(#f1234idh)"
          ></circle>
          <g filter="url(#f1234id1u)">
            <circle
              cx="13.652"
              cy="13.975"
              r="1.187"
              fill="url(#f1234id1f)"
            ></circle>
          </g>
          <g filter="url(#f1234id1v)">
            <circle
              cx="24.998"
              cy="13.975"
              r="1.991"
              fill="url(#f1234id1g)"
            ></circle>
            <circle
              cx="24.998"
              cy="13.975"
              r="1.991"
              fill="url(#f1234idi)"
            ></circle>
          </g>
          <g filter="url(#f1234id1w)">
            <circle cx="24.998" cy="13.975" r="1.187" fill="#FFBF34"></circle>
            <circle
              cx="24.998"
              cy="13.975"
              r="1.187"
              fill="url(#f1234idj)"
            ></circle>
            <circle
              cx="24.998"
              cy="13.975"
              r="1.187"
              fill="url(#f1234idk)"
            ></circle>
          </g>
          <path
            fill="url(#f1234id1h)"
            d="M13.232 13.244a36 36 0 0 1-.07-1.716c0-.318.128-.7.384-.89l.192-.191c.32-.254.448-.636.448-1.018V8.411a.62.62 0 0 1 .512-.636c.768-.19 2.367-.509 4.67-.509s3.902.319 4.67.51c.256.063.512.317.512.635V9.43c0 .382.192.764.448 1.018c.598.42.561.65.511 1.145c-.015.153-.064 1.425-.106 1.717l-.317 4.721c-.191 2.11-1.85 3.581-3.829 3.581h-3.829c-2.042 0-3.637-1.47-3.829-3.581z"
          ></path>
          <path
            fill="url(#f1234id1i)"
            d="M13.232 13.244a36 36 0 0 1-.07-1.716c0-.318.128-.7.384-.89l.192-.191c.32-.254.448-.636.448-1.018V8.411a.62.62 0 0 1 .512-.636c.768-.19 2.367-.509 4.67-.509s3.902.319 4.67.51c.256.063.512.317.512.635V9.43c0 .382.192.764.448 1.018c.598.42.561.65.511 1.145c-.015.153-.064 1.425-.106 1.717l-.317 4.721c-.191 2.11-1.85 3.581-3.829 3.581h-3.829c-2.042 0-3.637-1.47-3.829-3.581z"
          ></path>
          <path
            fill="url(#f1234idl)"
            d="M13.232 13.244a36 36 0 0 1-.07-1.716c0-.318.128-.7.384-.89l.192-.191c.32-.254.448-.636.448-1.018V8.411a.62.62 0 0 1 .512-.636c.768-.19 2.367-.509 4.67-.509s3.902.319 4.67.51c.256.063.512.317.512.635V9.43c0 .382.192.764.448 1.018c.598.42.561.65.511 1.145c-.015.153-.064 1.425-.106 1.717l-.317 4.721c-.191 2.11-1.85 3.581-3.829 3.581h-3.829c-2.042 0-3.637-1.47-3.829-3.581z"
          ></path>
          <path
            fill="url(#f1234idm)"
            d="M13.232 13.244a36 36 0 0 1-.07-1.716c0-.318.128-.7.384-.89l.192-.191c.32-.254.448-.636.448-1.018V8.411a.62.62 0 0 1 .512-.636c.768-.19 2.367-.509 4.67-.509s3.902.319 4.67.51c.256.063.512.317.512.635V9.43c0 .382.192.764.448 1.018c.598.42.561.65.511 1.145c-.015.153-.064 1.425-.106 1.717l-.317 4.721c-.191 2.11-1.85 3.581-3.829 3.581h-3.829c-2.042 0-3.637-1.47-3.829-3.581z"
          ></path>
          <path
            fill="url(#f1234idn)"
            d="M13.232 13.244a36 36 0 0 1-.07-1.716c0-.318.128-.7.384-.89l.192-.191c.32-.254.448-.636.448-1.018V8.411a.62.62 0 0 1 .512-.636c.768-.19 2.367-.509 4.67-.509s3.902.319 4.67.51c.256.063.512.317.512.635V9.43c0 .382.192.764.448 1.018c.598.42.561.65.511 1.145c-.015.153-.064 1.425-.106 1.717l-.317 4.721c-.191 2.11-1.85 3.581-3.829 3.581h-3.829c-2.042 0-3.637-1.47-3.829-3.581z"
          ></path>
          <g filter="url(#f1234id1x)">
            <path
              fill="#FFA91B"
              d="m25.061 6.249l.512.254c.896.446 1.408 1.463 1.216 2.545l-.704 3.625c-.063.375-.31.627-.682.636c.042-.6.082-1.57.097-1.723c.052-.516-.029-.668-.503-1.14c-.256-.253-.447-.635-.447-1.017V8.411c0-.318-.256-.572-.512-.636c-.768-.19-2.367-.508-4.67-.508s-3.902.318-4.67.508a.62.62 0 0 0-.512.636V9.43c0 .382-.128.764-.448 1.018l-.192.19c-.256.192-.385.59-.385.908c.017.186.042 1.254.07 1.699a.755.755 0 0 1-.708-.634l-.704-3.626c-.128-1.018.384-2.035 1.28-2.48c1.208-.53 1.65-1.335 2.622-2.163c.704-.637 1.728-.827 2.623-.382c.64.19 1.344.19 1.983 0c.96-.318 2.047-.064 2.815.636l.96.954c.256.318.575.509.96.7"
            ></path>
            <path
              fill="url(#f1234ido)"
              d="m25.061 6.249l.512.254c.896.446 1.408 1.463 1.216 2.545l-.704 3.625c-.063.375-.31.627-.682.636c.042-.6.082-1.57.097-1.723c.052-.516-.029-.668-.503-1.14c-.256-.253-.447-.635-.447-1.017V8.411c0-.318-.256-.572-.512-.636c-.768-.19-2.367-.508-4.67-.508s-3.902.318-4.67.508a.62.62 0 0 0-.512.636V9.43c0 .382-.128.764-.448 1.018l-.192.19c-.256.192-.385.59-.385.908c.017.186.042 1.254.07 1.699a.755.755 0 0 1-.708-.634l-.704-3.626c-.128-1.018.384-2.035 1.28-2.48c1.208-.53 1.65-1.335 2.622-2.163c.704-.637 1.728-.827 2.623-.382c.64.19 1.344.19 1.983 0c.96-.318 2.047-.064 2.815.636l.96.954c.256.318.575.509.96.7"
            ></path>
            <path
              fill="url(#f1234id1j)"
              d="m25.061 6.249l.512.254c.896.446 1.408 1.463 1.216 2.545l-.704 3.625c-.063.375-.31.627-.682.636c.042-.6.082-1.57.097-1.723c.052-.516-.029-.668-.503-1.14c-.256-.253-.447-.635-.447-1.017V8.411c0-.318-.256-.572-.512-.636c-.768-.19-2.367-.508-4.67-.508s-3.902.318-4.67.508a.62.62 0 0 0-.512.636V9.43c0 .382-.128.764-.448 1.018l-.192.19c-.256.192-.385.59-.385.908c.017.186.042 1.254.07 1.699a.755.755 0 0 1-.708-.634l-.704-3.626c-.128-1.018.384-2.035 1.28-2.48c1.208-.53 1.65-1.335 2.622-2.163c.704-.637 1.728-.827 2.623-.382c.64.19 1.344.19 1.983 0c.96-.318 2.047-.064 2.815.636l.96.954c.256.318.575.509.96.7"
            ></path>
            <path
              fill="url(#f1234idp)"
              d="m25.061 6.249l.512.254c.896.446 1.408 1.463 1.216 2.545l-.704 3.625c-.063.375-.31.627-.682.636c.042-.6.082-1.57.097-1.723c.052-.516-.029-.668-.503-1.14c-.256-.253-.447-.635-.447-1.017V8.411c0-.318-.256-.572-.512-.636c-.768-.19-2.367-.508-4.67-.508s-3.902.318-4.67.508a.62.62 0 0 0-.512.636V9.43c0 .382-.128.764-.448 1.018l-.192.19c-.256.192-.385.59-.385.908c.017.186.042 1.254.07 1.699a.755.755 0 0 1-.708-.634l-.704-3.626c-.128-1.018.384-2.035 1.28-2.48c1.208-.53 1.65-1.335 2.622-2.163c.704-.637 1.728-.827 2.623-.382c.64.19 1.344.19 1.983 0c.96-.318 2.047-.064 2.815.636l.96.954c.256.318.575.509.96.7"
            ></path>
            <path
              fill="url(#f1234idq)"
              d="m25.061 6.249l.512.254c.896.446 1.408 1.463 1.216 2.545l-.704 3.625c-.063.375-.31.627-.682.636c.042-.6.082-1.57.097-1.723c.052-.516-.029-.668-.503-1.14c-.256-.253-.447-.635-.447-1.017V8.411c0-.318-.256-.572-.512-.636c-.768-.19-2.367-.508-4.67-.508s-3.902.318-4.67.508a.62.62 0 0 0-.512.636V9.43c0 .382-.128.764-.448 1.018l-.192.19c-.256.192-.385.59-.385.908c.017.186.042 1.254.07 1.699a.755.755 0 0 1-.708-.634l-.704-3.626c-.128-1.018.384-2.035 1.28-2.48c1.208-.53 1.65-1.335 2.622-2.163c.704-.637 1.728-.827 2.623-.382c.64.19 1.344.19 1.983 0c.96-.318 2.047-.064 2.815.636l.96.954c.256.318.575.509.96.7"
            ></path>
            <path
              fill="url(#f1234idr)"
              d="m25.061 6.249l.512.254c.896.446 1.408 1.463 1.216 2.545l-.704 3.625c-.063.375-.31.627-.682.636c.042-.6.082-1.57.097-1.723c.052-.516-.029-.668-.503-1.14c-.256-.253-.447-.635-.447-1.017V8.411c0-.318-.256-.572-.512-.636c-.768-.19-2.367-.508-4.67-.508s-3.902.318-4.67.508a.62.62 0 0 0-.512.636V9.43c0 .382-.128.764-.448 1.018l-.192.19c-.256.192-.385.59-.385.908c.017.186.042 1.254.07 1.699a.755.755 0 0 1-.708-.634l-.704-3.626c-.128-1.018.384-2.035 1.28-2.48c1.208-.53 1.65-1.335 2.622-2.163c.704-.637 1.728-.827 2.623-.382c.64.19 1.344.19 1.983 0c.96-.318 2.047-.064 2.815.636l.96.954c.256.318.575.509.96.7"
            ></path>
            <path
              fill="url(#f1234ids)"
              d="m25.061 6.249l.512.254c.896.446 1.408 1.463 1.216 2.545l-.704 3.625c-.063.375-.31.627-.682.636c.042-.6.082-1.57.097-1.723c.052-.516-.029-.668-.503-1.14c-.256-.253-.447-.635-.447-1.017V8.411c0-.318-.256-.572-.512-.636c-.768-.19-2.367-.508-4.67-.508s-3.902.318-4.67.508a.62.62 0 0 0-.512.636V9.43c0 .382-.128.764-.448 1.018l-.192.19c-.256.192-.385.59-.385.908c.017.186.042 1.254.07 1.699a.755.755 0 0 1-.708-.634l-.704-3.626c-.128-1.018.384-2.035 1.28-2.48c1.208-.53 1.65-1.335 2.622-2.163c.704-.637 1.728-.827 2.623-.382c.64.19 1.344.19 1.983 0c.96-.318 2.047-.064 2.815.636l.96.954c.256.318.575.509.96.7"
            ></path>
          </g>
          <path
            fill="url(#f1234idt)"
            d="m25.061 6.249l.512.254c.896.446 1.408 1.463 1.216 2.545l-.704 3.625c-.063.375-.31.627-.682.636c.042-.6.082-1.57.097-1.723c.052-.516-.029-.668-.503-1.14c-.256-.253-.447-.635-.447-1.017V8.411c0-.318-.256-.572-.512-.636c-.768-.19-2.367-.508-4.67-.508s-3.902.318-4.67.508a.62.62 0 0 0-.512.636V9.43c0 .382-.128.764-.448 1.018l-.192.19c-.256.192-.385.59-.385.908c.017.186.042 1.254.07 1.699a.755.755 0 0 1-.708-.634l-.704-3.626c-.128-1.018.384-2.035 1.28-2.48c1.208-.53 1.65-1.335 2.622-2.163c.704-.637 1.728-.827 2.623-.382c.64.19 1.344.19 1.983 0c.96-.318 2.047-.064 2.815.636l.96.954c.256.318.575.509.96.7"
          ></path>
          <path
            fill="url(#f1234idu)"
            d="m25.061 6.249l.512.254c.896.446 1.408 1.463 1.216 2.545l-.704 3.625c-.063.375-.31.627-.682.636c.042-.6.082-1.57.097-1.723c.052-.516-.029-.668-.503-1.14c-.256-.253-.447-.635-.447-1.017V8.411c0-.318-.256-.572-.512-.636c-.768-.19-2.367-.508-4.67-.508s-3.902.318-4.67.508a.62.62 0 0 0-.512.636V9.43c0 .382-.128.764-.448 1.018l-.192.19c-.256.192-.385.59-.385.908c.017.186.042 1.254.07 1.699a.755.755 0 0 1-.708-.634l-.704-3.626c-.128-1.018.384-2.035 1.28-2.48c1.208-.53 1.65-1.335 2.622-2.163c.704-.637 1.728-.827 2.623-.382c.64.19 1.344.19 1.983 0c.96-.318 2.047-.064 2.815.636l.96.954c.256.318.575.509.96.7"
          ></path>
          <path
            fill="url(#f1234idv)"
            d="m25.061 6.249l.512.254c.896.446 1.408 1.463 1.216 2.545l-.704 3.625c-.063.375-.31.627-.682.636c.042-.6.082-1.57.097-1.723c.052-.516-.029-.668-.503-1.14c-.256-.253-.447-.635-.447-1.017V8.411c0-.318-.256-.572-.512-.636c-.768-.19-2.367-.508-4.67-.508s-3.902.318-4.67.508a.62.62 0 0 0-.512.636V9.43c0 .382-.128.764-.448 1.018l-.192.19c-.256.192-.385.59-.385.908c.017.186.042 1.254.07 1.699a.755.755 0 0 1-.708-.634l-.704-3.626c-.128-1.018.384-2.035 1.28-2.48c1.208-.53 1.65-1.335 2.622-2.163c.704-.637 1.728-.827 2.623-.382c.64.19 1.344.19 1.983 0c.96-.318 2.047-.064 2.815.636l.96.954c.256.318.575.509.96.7"
          ></path>
          <g filter="url(#f1234id1y)">
            <path
              fill="#F1901C"
              d="m18.986 13.829l-.979 2.027c-.12.417.17.834.583.834h.879c.412 0 .703-.424.582-.834l-.594-2.027c-.128-.45-.338-.45-.471 0"
            ></path>
          </g>
          <g filter="url(#f1234id1z)">
            <path
              fill="#FFCC28"
              d="m18.858 13.634l-.633 2.027a.643.643 0 0 0 .62.834h.938c.44 0 .75-.423.62-.834l-.633-2.027c-.136-.449-.77-.449-.912 0"
            ></path>
            <path
              fill="url(#f1234id1k)"
              d="m18.858 13.634l-.633 2.027a.643.643 0 0 0 .62.834h.938c.44 0 .75-.423.62-.834l-.633-2.027c-.136-.449-.77-.449-.912 0"
            ></path>
            <path
              fill="url(#f1234id1l)"
              d="m18.858 13.634l-.633 2.027a.643.643 0 0 0 .62.834h.938c.44 0 .75-.423.62-.834l-.633-2.027c-.136-.449-.77-.449-.912 0"
            ></path>
            <path
              fill="url(#f1234id1m)"
              d="m18.858 13.634l-.633 2.027a.643.643 0 0 0 .62.834h.938c.44 0 .75-.423.62-.834l-.633-2.027c-.136-.449-.77-.449-.912 0"
            ></path>
          </g>
          <path
            fill="url(#f1234id1n)"
            d="m18.858 13.634l-.633 2.027a.643.643 0 0 0 .62.834h.938c.44 0 .75-.423.62-.834l-.633-2.027c-.136-.449-.77-.449-.912 0"
          ></path>
          <g filter="url(#f1234id20)">
            <path
              stroke="url(#f1234idw)"
              strokeWidth=".2"
              d="M19.314 17.707a3.6 3.6 0 0 1-1.652-.391c-.163-.083-.339.1-.236.249a2.26 2.26 0 0 0 1.888 1.009c.793 0 1.489-.404 1.888-1.009c.103-.154-.073-.332-.236-.25c-.478.25-1.04.392-1.652.392Z"
            ></path>
          </g>
          <path
            fill="#8A004F"
            d="M19.314 17.707a3.6 3.6 0 0 1-1.652-.391c-.163-.083-.339.1-.236.249a2.26 2.26 0 0 0 1.888 1.009c.793 0 1.489-.404 1.888-1.009c.103-.154-.073-.332-.236-.25c-.478.25-1.04.392-1.652.392"
          ></path>
          <path
            fill="#fff"
            d="M22.162 12.268c.779 0 1.437.537 1.616 1.263a.327.327 0 0 1-.32.406h-2.66a.274.274 0 0 1-.27-.324a1.67 1.67 0 0 1 1.634-1.345"
          ></path>
          <path
            fill="url(#f1234idx)"
            d="M21.915 12.592a1.064 1.064 0 0 1 1.025 1.344h-2.055a1.068 1.068 0 0 1 1.03-1.344"
          ></path>
          <path
            fill="#000"
            d="M21.306 13.656c0-.338.27-.609.609-.609a.607.607 0 0 1 .541.89h-1.078a.55.55 0 0 1-.072-.28"
          ></path>
          <g filter="url(#f1234id21)">
            <path
              fill="#C7A7A3"
              d="M21.837 12.817c.076.102-.083.225-.263.36s-.314.23-.39.128c-.075-.101.01-.293.19-.427c.18-.135.387-.162.463-.06"
            ></path>
            <path
              fill="url(#f1234idy)"
              d="M21.837 12.817c.076.102-.083.225-.263.36s-.314.23-.39.128c-.075-.101.01-.293.19-.427c.18-.135.387-.162.463-.06"
            ></path>
          </g>
          <g filter="url(#f1234id22)">
            <path
              fill="url(#f1234id1o)"
              d="M22.863 13.516a1 1 0 0 0-.276-.551l-.31.34l.14.272z"
            ></path>
          </g>
          <path
            fill="#fff"
            d="M16.46 12.268c-.779 0-1.437.537-1.616 1.263a.327.327 0 0 0 .32.406h2.66c.17 0 .305-.155.271-.324a1.67 1.67 0 0 0-1.635-1.345"
          ></path>
          <path
            fill="url(#f1234idz)"
            d="M16.707 12.592a1.064 1.064 0 0 0-1.026 1.344h2.055a1 1 0 0 0 .04-.28a1.07 1.07 0 0 0-1.07-1.064"
          ></path>
          <path
            fill="#000"
            d="M17.316 13.656c0-.338-.27-.61-.61-.61a.607.607 0 0 0-.54.89h1.077a.6.6 0 0 0 .073-.28"
          ></path>
          <g filter="url(#f1234id23)">
            <path
              fill="url(#f1234id1p)"
              d="M17.68 13.531c0-.344-.28-.573-.356-.642l-.344.333l.212.43z"
            ></path>
          </g>
          <g filter="url(#f1234id24)">
            <ellipse
              cx="16.386"
              cy="13.047"
              fill="#C7A7A3"
              fillOpacity=".9"
              rx=".465"
              ry=".235"
              transform="rotate(-27.914 16.386 13.047)"
            ></ellipse>
            <ellipse
              cx="16.386"
              cy="13.047"
              fill="url(#f1234id10)"
              rx=".465"
              ry=".235"
              transform="rotate(-27.914 16.386 13.047)"
            ></ellipse>
          </g>
          <g filter="url(#f1234id25)">
            <path
              fill="url(#f1234id11)"
              fillRule="evenodd"
              d="M21.437 11.344c.858-.08 1.409.255 1.542.378a.563.563 0 0 0 .764-.829c-.365-.336-1.23-.781-2.411-.67a.563.563 0 1 0 .105 1.121"
              clipRule="evenodd"
            ></path>
          </g>
          <g filter="url(#f1234id26)">
            <path
              stroke="#D76D5B"
              strokeLinecap="round"
              strokeWidth=".25"
              d="M23.36 11.175c-.248-.23-.956-.62-1.975-.524"
            ></path>
          </g>
          <g filter="url(#f1234id27)">
            <path
              fill="url(#f1234id12)"
              fillRule="evenodd"
              d="M17.192 11.344c-.859-.08-1.41.255-1.543.378a.563.563 0 1 1-.763-.829c.365-.336 1.23-.781 2.41-.67a.563.563 0 0 1-.104 1.121"
              clipRule="evenodd"
            ></path>
          </g>
          <g filter="url(#f1234id28)">
            <path
              stroke="#D76D5B"
              strokeLinecap="round"
              strokeWidth=".25"
              d="M15.268 11.175c.249-.23.956-.62 1.975-.524"
            ></path>
          </g>
          <defs>
            <radialGradient
              id="f1234id0"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(2.33335 -6.04232 7.22855 2.79144 6.184 11.647)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".475" stopColor="#F4B937"></stop>
              <stop offset="1" stopColor="#F2B830"></stop>
              <stop offset="1" stopColor="#EEB32A"></stop>
            </radialGradient>
            <radialGradient
              id="f1234id1"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(130.764 2.988 7.274)scale(9.5721 2.30417)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".147" stopColor="#C58235"></stop>
              <stop offset="1" stopColor="#D6952A" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234id2"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(.19531 2.2578 -.27074 .02342 4.91 4.833)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".415" stopColor="#E5A70F"></stop>
              <stop offset="1" stopColor="#EAAA15" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234id3"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.04685 3.40625 -.266 -.00366 6.559 3.669)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".401" stopColor="#EAAA15"></stop>
              <stop offset="1" stopColor="#EAAA15" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234id4"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.67188 3.96875 -.56716 -.09602 8.526 2.904)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".652" stopColor="#EAAA15"></stop>
              <stop offset="1" stopColor="#EAAA15" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234id5"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.89063 .84376 -.848 -.8951 9.87 3.45)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFDC45"></stop>
              <stop offset="1" stopColor="#FFDC45" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234id6"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(138.965 3.584 2.792)scale(1.11858 .93215)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFDC45"></stop>
              <stop offset="1" stopColor="#FFDC45" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234id7"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.46875 .71876 -.65233 -.42542 5.995 3.107)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFDC45"></stop>
              <stop offset="1" stopColor="#FFDC45" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234id8"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.5 .60938 -.55307 -.4538 4.416 4.389)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFDC45"></stop>
              <stop offset="1" stopColor="#FFDC45" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234id9"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(85.723 -.464 4.875)scale(2.30438 .44699)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFCC3D"></stop>
              <stop offset="1" stopColor="#FFCC3D" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234ida"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 1.10937 -1.15625 0 7.441 12.216)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#3A82C1"></stop>
              <stop offset="1" stopColor="#3A82C1" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idb"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-8.68288 2.79847 -2.9931 -9.28678 26.412 26.965)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4AB9FF"></stop>
              <stop offset="1" stopColor="#4AB9FF" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idc"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 -5.19204 2.98189 0 11.202 30.33)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#489BF9"></stop>
              <stop offset="1" stopColor="#489BF9" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idd"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 8.8125 -5.4375 0 3.292 12.763)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#47A1E2"></stop>
              <stop offset="1" stopColor="#47A1E2" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234ide"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(-167.876 10.078 9.128)scale(10.3399 4.20474)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".287" stopColor="#1E5F96"></stop>
              <stop offset="1" stopColor="#1C72C1" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idf"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-5.69115 0 0 -5.7286 12.062 15.675)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".132" stopColor="#387EC0"></stop>
              <stop offset="1" stopColor="#387EC0" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idg"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 1.15625 -2.61254 0 19.325 21.056)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#E97E36"></stop>
              <stop offset="1" stopColor="#E97E36" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idh"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(2.09293 0 0 3.66264 11.66 13.975)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".351" stopColor="#E6962B"></stop>
              <stop offset="1" stopColor="#CA8F29"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idi"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(.98596 -.71793 .81942 1.12535 25.441 13.659)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".543" stopColor="#FFC532"></stop>
              <stop offset="1" stopColor="#FFC532" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idj"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(-61.467 25.05 -13.504)scale(2.05057 1.20021)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".69" stopColor="#F4A51A" stopOpacity="0"></stop>
              <stop offset="1" stopColor="#F4A51A"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idk"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(.30924 .3061 -.3946 .39865 24.998 13.975)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#E59B1F"></stop>
              <stop offset="1" stopColor="#E59B1F" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idl"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-1.11483 10.44417 -15.37277 -1.64092 21.729 12.261)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".559" stopColor="#FDA42B" stopOpacity="0"></stop>
              <stop offset=".799" stopColor="#E5883F"></stop>
              <stop offset="1" stopColor="#B17B57"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idm"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 -1.55888 1.91862 0 22.112 12.458)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFBA0D"></stop>
              <stop offset="1" stopColor="#FFBA0D" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idn"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 -1.65881 2.06288 0 16.676 12.418)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#EE911A"></stop>
              <stop offset="1" stopColor="#EE911A" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234ido"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-4.09865 5.28261 -8.98353 -6.9701 23.718 4.776)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFE336"></stop>
              <stop offset="1" stopColor="#FFE336" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idp"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.22003 -2.37635 1.16708 -.10806 14.381 9.635)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".222" stopColor="#FFB42C"></stop>
              <stop offset="1" stopColor="#FFB42C" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idq"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(1.02464 -2.34531 1.91279 .83568 24.355 11.902)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".479" stopColor="#E57D1C"></stop>
              <stop offset="1" stopColor="#E57D1C" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idr"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(1.18404 1.46918 -1.29718 1.04542 18.389 3.717)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFCE2C"></stop>
              <stop offset="1" stopColor="#FFCE2C" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234ids"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(1.73052 -3.62043 1.2509 .59792 24.31 8.942)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFD93A"></stop>
              <stop offset="1" stopColor="#FFD93A" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idt"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(.31148 1.21042 -1.98999 .51209 20.144 3.716)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".208" stopColor="#DDB13B"></stop>
              <stop offset="1" stopColor="#FFC926" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idu"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(1.32019 1.90695 -3.96834 2.7473 14.088 5.22)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".288" stopColor="#C9993E"></stop>
              <stop offset="1" stopColor="#F29322" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idv"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-8.59594 3.87255 -4.84567 -10.75598 20.689 8.77)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".756" stopColor="#CF7D35" stopOpacity="0"></stop>
              <stop offset=".959" stopColor="#CF7D35"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idw"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(.02934 -.74811 2.24431 .08802 19.212 18.76)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFD069"></stop>
              <stop offset="1" stopColor="#FFBE30" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idx"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 1.07667 -1.27398 0 21.912 13.558)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".75" stopColor="#925C51"></stop>
              <stop offset="1" stopColor="#694B43"></stop>
              <stop offset="1" stopColor="#804D49"></stop>
              <stop offset="1" stopColor="#85534D"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idy"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.27653 -.35635 .4906 -.38072 21.64 13.261)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".766" stopColor="#FFE6E2" stopOpacity="0"></stop>
              <stop offset=".966" stopColor="#FFE6E2"></stop>
            </radialGradient>
            <radialGradient
              id="f1234idz"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 1.07672 -1.27405 0 16.709 13.558)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".75" stopColor="#925C51"></stop>
              <stop offset="1" stopColor="#694B43"></stop>
              <stop offset="1" stopColor="#804D49"></stop>
              <stop offset="1" stopColor="#85534D"></stop>
            </radialGradient>
            <radialGradient
              id="f1234id10"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.00922 -.58913 .70816 -.01109 16.368 13.422)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".766" stopColor="#FFE6E2" stopOpacity="0"></stop>
              <stop offset=".966" stopColor="#FFE6E2"></stop>
            </radialGradient>
            <radialGradient
              id="f1234id11"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(.2347 -.96814 2.12396 .5149 22.237 11.352)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".657" stopColor="#C64F38"></stop>
              <stop offset="1" stopColor="#BB4F29"></stop>
            </radialGradient>
            <radialGradient
              id="f1234id12"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.2347 -.96814 2.12396 -.5149 16.391 11.352)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".657" stopColor="#C64F38"></stop>
              <stop offset="1" stopColor="#BB4F29"></stop>
            </radialGradient>
            <linearGradient
              id="f1234id13"
              x1="6.667"
              x2="6.667"
              y1="12.307"
              y2="10.604"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".198" stopColor="#B0851E"></stop>
              <stop offset="1" stopColor="#F6BB38" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id14"
              x1="4.511"
              x2="8.886"
              y1="12.326"
              y2="12.326"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4B93C9"></stop>
              <stop offset=".743" stopColor="#3372A1"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id15"
              x1="6.78"
              x2="6.78"
              y1="11.74"
              y2="11.998"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#36749F"></stop>
              <stop offset="1" stopColor="#36749F" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id16"
              x1="18.102"
              x2="5.771"
              y1="28.205"
              y2="12.763"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2497FE"></stop>
              <stop offset=".197" stopColor="#2893F2"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id17"
              x1="9.777"
              x2="11.734"
              y1="26.431"
              y2="20.147"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".1" stopColor="#47F"></stop>
              <stop offset="1" stopColor="#47F" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id18"
              x1="14.046"
              x2="13.307"
              y1="24.456"
              y2="23.06"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".213" stopColor="#398FFA"></stop>
              <stop offset=".732" stopColor="#398FFA" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id19"
              x1="7.307"
              x2="7.307"
              y1="12.763"
              y2="13.803"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4590CB"></stop>
              <stop offset="1" stopColor="#4590CB" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id1a"
              x1="17.636"
              x2="19.636"
              y1="20.494"
              y2="23.869"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#D16C15"></stop>
              <stop offset="1" stopColor="#FFC436"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id1b"
              x1="7.323"
              x2="13.073"
              y1="14.471"
              y2="22.752"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#56A6FF"></stop>
              <stop offset="1" stopColor="#56A6FF" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id1c"
              x1="4.918"
              x2="5.07"
              y1="4.95"
              y2="6.466"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#BB7401"></stop>
              <stop offset="1" stopColor="#EDAD18"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id1d"
              x1="6.504"
              x2="6.987"
              y1="4.161"
              y2="6.273"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#BB7401"></stop>
              <stop offset="1" stopColor="#EDAD18"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id1e"
              x1="8.082"
              x2="8.185"
              y1="5.242"
              y2="6.53"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#BB7401"></stop>
              <stop offset="1" stopColor="#EDAD18"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id1f"
              x1="13.652"
              x2="12.888"
              y1="14.307"
              y2="14.307"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#BD6A1E"></stop>
              <stop offset="1" stopColor="#D77A1C"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id1g"
              x1="26.293"
              x2="25.317"
              y1="12.673"
              y2="15.697"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFE446"></stop>
              <stop offset="1" stopColor="#FFC339"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id1h"
              x1="24.128"
              x2="15.02"
              y1="14.439"
              y2="15.796"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFE833"></stop>
              <stop offset="1" stopColor="#FFAC1B"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id1i"
              x1="12.879"
              x2="15.637"
              y1="17.654"
              y2="17.295"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#D19C3A"></stop>
              <stop offset="1" stopColor="#D19C3A" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id1j"
              x1="13.517"
              x2="16.978"
              y1="13.656"
              y2="7.508"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#E07027"></stop>
              <stop offset="1" stopColor="#E07027" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id1k"
              x1="18.284"
              x2="19.402"
              y1="15.225"
              y2="15.225"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FAA416"></stop>
              <stop offset="1" stopColor="#FAA416" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id1l"
              x1="20.433"
              x2="19.21"
              y1="15.61"
              y2="15.592"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFE721"></stop>
              <stop offset="1" stopColor="#FFE721" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id1m"
              x1="19.546"
              x2="19.546"
              y1="16.495"
              y2="15.812"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#EB8A1C"></stop>
              <stop offset="1" stopColor="#EB8A1C" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id1n"
              x1="19.464"
              x2="19.464"
              y1="16.545"
              y2="16.345"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#E88613"></stop>
              <stop offset="1" stopColor="#E88613" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id1o"
              x1="22.84"
              x2="22.466"
              y1="13.225"
              y2="13.456"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#B4948D"></stop>
              <stop offset="1" stopColor="#B4948D" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f1234id1p"
              x1="17.596"
              x2="17.222"
              y1="13.225"
              y2="13.456"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#B4948D"></stop>
              <stop offset="1" stopColor="#B4948D" stopOpacity="0"></stop>
            </linearGradient>
            <filter
              id="f1234id1q"
              width="9.217"
              height="11.911"
              x="5.667"
              y="12.191"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3861"
                stdDeviation=".75"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f1234id1r"
              width=".407"
              height="1.694"
              x="4.78"
              y="4.813"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3861"
                stdDeviation=".05"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f1234id1s"
              width=".369"
              height="2.337"
              x="6.319"
              y="3.899"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3861"
                stdDeviation=".05"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f1234id1t"
              width=".431"
              height="1.478"
              x="7.866"
              y="5.031"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3861"
                stdDeviation=".05"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f1234id1u"
              width="3.373"
              height="3.373"
              x="11.965"
              y="12.288"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3861"
                stdDeviation=".25"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f1234id1v"
              width="4.232"
              height="4.232"
              x="23.007"
              y="11.733"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dx=".25" dy="-.25"></feOffset>
              <feGaussianBlur stdDeviation=".25"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 0.85098 0 0 0 0 0.560784 0 0 0 0 0.376471 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect1_innerShadow_4002_3861"
              ></feBlend>
            </filter>
            <filter
              id="f1234id1w"
              width="3.373"
              height="3.373"
              x="23.311"
              y="12.288"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3861"
                stdDeviation=".25"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f1234id1x"
              width="15.029"
              height="10.093"
              x="11.8"
              y="3.216"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dy="-.5"></feOffset>
              <feGaussianBlur stdDeviation=".375"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 0.984314 0 0 0 0 0.584314 0 0 0 0 0.129412 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect1_innerShadow_4002_3861"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dy="-.25"></feOffset>
              <feGaussianBlur stdDeviation=".125"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 0.972549 0 0 0 0 0.572549 0 0 0 0 0.0156863 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="effect1_innerShadow_4002_3861"
                result="effect2_innerShadow_4002_3861"
              ></feBlend>
            </filter>
            <filter
              id="f1234id1y"
              width="3.599"
              height="4.698"
              x="17.23"
              y="12.742"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3861"
                stdDeviation=".375"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f1234id1z"
              width="2.738"
              height="3.698"
              x="17.945"
              y="13.047"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3861"
                stdDeviation=".125"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f1234id20"
              width="4.237"
              height="1.679"
              x="17.195"
              y="17.095"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3861"
                stdDeviation=".05"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f1234id21"
              width=".9"
              height=".792"
              x="21.057"
              y="12.656"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3861"
                stdDeviation=".05"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f1234id22"
              width=".986"
              height="1.012"
              x="22.077"
              y="12.765"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3861"
                stdDeviation=".1"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f1234id23"
              width="1.099"
              height="1.163"
              x="16.78"
              y="12.689"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3861"
                stdDeviation=".1"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f1234id24"
              width="1.05"
              height=".802"
              x="15.861"
              y="12.646"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3861"
                stdDeviation=".05"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f1234id25"
              width="3.103"
              height="1.916"
              x="20.821"
              y="9.955"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dy="-.25"></feOffset>
              <feGaussianBlur stdDeviation=".2"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 0.698039 0 0 0 0 0.25098 0 0 0 0 0.313726 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect1_innerShadow_4002_3861"
              ></feBlend>
            </filter>
            <filter
              id="f1234id26"
              width="3.026"
              height="1.589"
              x="20.86"
              y="10.111"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3861"
                stdDeviation=".2"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f1234id27"
              width="3.103"
              height="1.916"
              x="14.704"
              y="9.955"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dy="-.25"></feOffset>
              <feGaussianBlur stdDeviation=".2"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 0.698039 0 0 0 0 0.25098 0 0 0 0 0.313726 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect1_innerShadow_4002_3861"
              ></feBlend>
            </filter>
            <filter
              id="f1234id28"
              width="3.026"
              height="1.589"
              x="14.743"
              y="10.111"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3861"
                stdDeviation=".2"
              ></feGaussianBlur>
            </filter>
          </defs>
        </g>
      </svg>
    );
  };
  
  export const HbrHandsUpFemale=({width,height,handleClick})=>{
    return(
      <svg
      onClick={handleClick}
        viewBox="0 0 32 32"
        width={width}
        height={height}
      >
        <g fill="none">
          <g filter="url(#f2931id1e)">
            <path
              fill="url(#f2931id23)"
              fillRule="evenodd"
              d="M28.352 16.197c.26-.53.395-1.122.395-1.74c0-.569-.117-1.103-.327-1.59h.006a4 4 0 0 0-.343-.626l-.002-.004a3.95 3.95 0 0 1-.642-2.159v-.012a4.02 4.02 0 0 0-4.021-4.022a.66.66 0 0 1-.555-.283a4.03 4.03 0 0 0-3.27-1.678a4.03 4.03 0 0 0-3.269 1.678a.69.69 0 0 1-.555.283l-.104.002a4.02 4.02 0 0 0-3.917 4.02v.012a3.95 3.95 0 0 1-.642 2.16l-.003.004a4.02 4.02 0 0 0-.268 3.955a.63.63 0 0 1 0 .555a4 4 0 0 0-.395 1.715a3.917 3.917 0 0 0 3.923 3.923h10.461a3.917 3.917 0 0 0 3.923-3.923c0-.617-.148-1.197-.395-1.715a.63.63 0 0 1 0-.555M13.407 12.94h-.015l1.461 2.87c.15 3.417 1.484 0 4.74 0s4.677 3.803 4.827.387l1.385-3.897c-.066-1.518-1.165-1.624-1.385-1.624h-3.925a4.71 4.71 0 0 1-3.888-2.04a.321.321 0 0 0-.562.062l-.1.237a2.8 2.8 0 0 1-1.513 1.53q-.033.014-.062.024c-.288.15-.963.597-.988 1.754l.013.373z"
              clipRule="evenodd"
            ></path>
            <path
              fill="url(#f2931id0)"
              fillRule="evenodd"
              d="M28.352 16.197c.26-.53.395-1.122.395-1.74c0-.569-.117-1.103-.327-1.59h.006a4 4 0 0 0-.343-.626l-.002-.004a3.95 3.95 0 0 1-.642-2.159v-.012a4.02 4.02 0 0 0-4.021-4.022a.66.66 0 0 1-.555-.283a4.03 4.03 0 0 0-3.27-1.678a4.03 4.03 0 0 0-3.269 1.678a.69.69 0 0 1-.555.283l-.104.002a4.02 4.02 0 0 0-3.917 4.02v.012a3.95 3.95 0 0 1-.642 2.16l-.003.004a4.02 4.02 0 0 0-.268 3.955a.63.63 0 0 1 0 .555a4 4 0 0 0-.395 1.715a3.917 3.917 0 0 0 3.923 3.923h10.461a3.917 3.917 0 0 0 3.923-3.923c0-.617-.148-1.197-.395-1.715a.63.63 0 0 1 0-.555M13.407 12.94h-.015l1.461 2.87c.15 3.417 1.484 0 4.74 0s4.677 3.803 4.827.387l1.385-3.897c-.066-1.518-1.165-1.624-1.385-1.624h-3.925a4.71 4.71 0 0 1-3.888-2.04a.321.321 0 0 0-.562.062l-.1.237a2.8 2.8 0 0 1-1.513 1.53q-.033.014-.062.024c-.288.15-.963.597-.988 1.754l.013.373z"
              clipRule="evenodd"
            ></path>
            <path
              fill="url(#f2931id1)"
              fillRule="evenodd"
              d="M28.352 16.197c.26-.53.395-1.122.395-1.74c0-.569-.117-1.103-.327-1.59h.006a4 4 0 0 0-.343-.626l-.002-.004a3.95 3.95 0 0 1-.642-2.159v-.012a4.02 4.02 0 0 0-4.021-4.022a.66.66 0 0 1-.555-.283a4.03 4.03 0 0 0-3.27-1.678a4.03 4.03 0 0 0-3.269 1.678a.69.69 0 0 1-.555.283l-.104.002a4.02 4.02 0 0 0-3.917 4.02v.012a3.95 3.95 0 0 1-.642 2.16l-.003.004a4.02 4.02 0 0 0-.268 3.955a.63.63 0 0 1 0 .555a4 4 0 0 0-.395 1.715a3.917 3.917 0 0 0 3.923 3.923h10.461a3.917 3.917 0 0 0 3.923-3.923c0-.617-.148-1.197-.395-1.715a.63.63 0 0 1 0-.555M13.407 12.94h-.015l1.461 2.87c.15 3.417 1.484 0 4.74 0s4.677 3.803 4.827.387l1.385-3.897c-.066-1.518-1.165-1.624-1.385-1.624h-3.925a4.71 4.71 0 0 1-3.888-2.04a.321.321 0 0 0-.562.062l-.1.237a2.8 2.8 0 0 1-1.513 1.53q-.033.014-.062.024c-.288.15-.963.597-.988 1.754l.013.373z"
              clipRule="evenodd"
            ></path>
            <path
              fill="url(#f2931id2)"
              fillRule="evenodd"
              d="M28.352 16.197c.26-.53.395-1.122.395-1.74c0-.569-.117-1.103-.327-1.59h.006a4 4 0 0 0-.343-.626l-.002-.004a3.95 3.95 0 0 1-.642-2.159v-.012a4.02 4.02 0 0 0-4.021-4.022a.66.66 0 0 1-.555-.283a4.03 4.03 0 0 0-3.27-1.678a4.03 4.03 0 0 0-3.269 1.678a.69.69 0 0 1-.555.283l-.104.002a4.02 4.02 0 0 0-3.917 4.02v.012a3.95 3.95 0 0 1-.642 2.16l-.003.004a4.02 4.02 0 0 0-.268 3.955a.63.63 0 0 1 0 .555a4 4 0 0 0-.395 1.715a3.917 3.917 0 0 0 3.923 3.923h10.461a3.917 3.917 0 0 0 3.923-3.923c0-.617-.148-1.197-.395-1.715a.63.63 0 0 1 0-.555M13.407 12.94h-.015l1.461 2.87c.15 3.417 1.484 0 4.74 0s4.677 3.803 4.827.387l1.385-3.897c-.066-1.518-1.165-1.624-1.385-1.624h-3.925a4.71 4.71 0 0 1-3.888-2.04a.321.321 0 0 0-.562.062l-.1.237a2.8 2.8 0 0 1-1.513 1.53q-.033.014-.062.024c-.288.15-.963.597-.988 1.754l.013.373z"
              clipRule="evenodd"
            ></path>
            <path
              fill="url(#f2931id3)"
              fillRule="evenodd"
              d="M28.352 16.197c.26-.53.395-1.122.395-1.74c0-.569-.117-1.103-.327-1.59h.006a4 4 0 0 0-.343-.626l-.002-.004a3.95 3.95 0 0 1-.642-2.159v-.012a4.02 4.02 0 0 0-4.021-4.022a.66.66 0 0 1-.555-.283a4.03 4.03 0 0 0-3.27-1.678a4.03 4.03 0 0 0-3.269 1.678a.69.69 0 0 1-.555.283l-.104.002a4.02 4.02 0 0 0-3.917 4.02v.012a3.95 3.95 0 0 1-.642 2.16l-.003.004a4.02 4.02 0 0 0-.268 3.955a.63.63 0 0 1 0 .555a4 4 0 0 0-.395 1.715a3.917 3.917 0 0 0 3.923 3.923h10.461a3.917 3.917 0 0 0 3.923-3.923c0-.617-.148-1.197-.395-1.715a.63.63 0 0 1 0-.555M13.407 12.94h-.015l1.461 2.87c.15 3.417 1.484 0 4.74 0s4.677 3.803 4.827.387l1.385-3.897c-.066-1.518-1.165-1.624-1.385-1.624h-3.925a4.71 4.71 0 0 1-3.888-2.04a.321.321 0 0 0-.562.062l-.1.237a2.8 2.8 0 0 1-1.513 1.53q-.033.014-.062.024c-.288.15-.963.597-.988 1.754l.013.373z"
              clipRule="evenodd"
            ></path>
            <path
              fill="url(#f2931id4)"
              fillRule="evenodd"
              d="M28.352 16.197c.26-.53.395-1.122.395-1.74c0-.569-.117-1.103-.327-1.59h.006a4 4 0 0 0-.343-.626l-.002-.004a3.95 3.95 0 0 1-.642-2.159v-.012a4.02 4.02 0 0 0-4.021-4.022a.66.66 0 0 1-.555-.283a4.03 4.03 0 0 0-3.27-1.678a4.03 4.03 0 0 0-3.269 1.678a.69.69 0 0 1-.555.283l-.104.002a4.02 4.02 0 0 0-3.917 4.02v.012a3.95 3.95 0 0 1-.642 2.16l-.003.004a4.02 4.02 0 0 0-.268 3.955a.63.63 0 0 1 0 .555a4 4 0 0 0-.395 1.715a3.917 3.917 0 0 0 3.923 3.923h10.461a3.917 3.917 0 0 0 3.923-3.923c0-.617-.148-1.197-.395-1.715a.63.63 0 0 1 0-.555M13.407 12.94h-.015l1.461 2.87c.15 3.417 1.484 0 4.74 0s4.677 3.803 4.827.387l1.385-3.897c-.066-1.518-1.165-1.624-1.385-1.624h-3.925a4.71 4.71 0 0 1-3.888-2.04a.321.321 0 0 0-.562.062l-.1.237a2.8 2.8 0 0 1-1.513 1.53q-.033.014-.062.024c-.288.15-.963.597-.988 1.754l.013.373z"
              clipRule="evenodd"
            ></path>
            <path
              fill="url(#f2931id5)"
              fillRule="evenodd"
              d="M28.352 16.197c.26-.53.395-1.122.395-1.74c0-.569-.117-1.103-.327-1.59h.006a4 4 0 0 0-.343-.626l-.002-.004a3.95 3.95 0 0 1-.642-2.159v-.012a4.02 4.02 0 0 0-4.021-4.022a.66.66 0 0 1-.555-.283a4.03 4.03 0 0 0-3.27-1.678a4.03 4.03 0 0 0-3.269 1.678a.69.69 0 0 1-.555.283l-.104.002a4.02 4.02 0 0 0-3.917 4.02v.012a3.95 3.95 0 0 1-.642 2.16l-.003.004a4.02 4.02 0 0 0-.268 3.955a.63.63 0 0 1 0 .555a4 4 0 0 0-.395 1.715a3.917 3.917 0 0 0 3.923 3.923h10.461a3.917 3.917 0 0 0 3.923-3.923c0-.617-.148-1.197-.395-1.715a.63.63 0 0 1 0-.555M13.407 12.94h-.015l1.461 2.87c.15 3.417 1.484 0 4.74 0s4.677 3.803 4.827.387l1.385-3.897c-.066-1.518-1.165-1.624-1.385-1.624h-3.925a4.71 4.71 0 0 1-3.888-2.04a.321.321 0 0 0-.562.062l-.1.237a2.8 2.8 0 0 1-1.513 1.53q-.033.014-.062.024c-.288.15-.963.597-.988 1.754l.013.373z"
              clipRule="evenodd"
            ></path>
            <path
              fill="url(#f2931id6)"
              fillRule="evenodd"
              d="M28.352 16.197c.26-.53.395-1.122.395-1.74c0-.569-.117-1.103-.327-1.59h.006a4 4 0 0 0-.343-.626l-.002-.004a3.95 3.95 0 0 1-.642-2.159v-.012a4.02 4.02 0 0 0-4.021-4.022a.66.66 0 0 1-.555-.283a4.03 4.03 0 0 0-3.27-1.678a4.03 4.03 0 0 0-3.269 1.678a.69.69 0 0 1-.555.283l-.104.002a4.02 4.02 0 0 0-3.917 4.02v.012a3.95 3.95 0 0 1-.642 2.16l-.003.004a4.02 4.02 0 0 0-.268 3.955a.63.63 0 0 1 0 .555a4 4 0 0 0-.395 1.715a3.917 3.917 0 0 0 3.923 3.923h10.461a3.917 3.917 0 0 0 3.923-3.923c0-.617-.148-1.197-.395-1.715a.63.63 0 0 1 0-.555M13.407 12.94h-.015l1.461 2.87c.15 3.417 1.484 0 4.74 0s4.677 3.803 4.827.387l1.385-3.897c-.066-1.518-1.165-1.624-1.385-1.624h-3.925a4.71 4.71 0 0 1-3.888-2.04a.321.321 0 0 0-.562.062l-.1.237a2.8 2.8 0 0 1-1.513 1.53q-.033.014-.062.024c-.288.15-.963.597-.988 1.754l.013.373z"
              clipRule="evenodd"
            ></path>
            <path
              fill="url(#f2931id7)"
              fillRule="evenodd"
              d="M28.352 16.197c.26-.53.395-1.122.395-1.74c0-.569-.117-1.103-.327-1.59h.006a4 4 0 0 0-.343-.626l-.002-.004a3.95 3.95 0 0 1-.642-2.159v-.012a4.02 4.02 0 0 0-4.021-4.022a.66.66 0 0 1-.555-.283a4.03 4.03 0 0 0-3.27-1.678a4.03 4.03 0 0 0-3.269 1.678a.69.69 0 0 1-.555.283l-.104.002a4.02 4.02 0 0 0-3.917 4.02v.012a3.95 3.95 0 0 1-.642 2.16l-.003.004a4.02 4.02 0 0 0-.268 3.955a.63.63 0 0 1 0 .555a4 4 0 0 0-.395 1.715a3.917 3.917 0 0 0 3.923 3.923h10.461a3.917 3.917 0 0 0 3.923-3.923c0-.617-.148-1.197-.395-1.715a.63.63 0 0 1 0-.555M13.407 12.94h-.015l1.461 2.87c.15 3.417 1.484 0 4.74 0s4.677 3.803 4.827.387l1.385-3.897c-.066-1.518-1.165-1.624-1.385-1.624h-3.925a4.71 4.71 0 0 1-3.888-2.04a.321.321 0 0 0-.562.062l-.1.237a2.8 2.8 0 0 1-1.513 1.53q-.033.014-.062.024c-.288.15-.963.597-.988 1.754l.013.373z"
              clipRule="evenodd"
            ></path>
            <path
              fill="url(#f2931id8)"
              fillRule="evenodd"
              d="M28.352 16.197c.26-.53.395-1.122.395-1.74c0-.569-.117-1.103-.327-1.59h.006a4 4 0 0 0-.343-.626l-.002-.004a3.95 3.95 0 0 1-.642-2.159v-.012a4.02 4.02 0 0 0-4.021-4.022a.66.66 0 0 1-.555-.283a4.03 4.03 0 0 0-3.27-1.678a4.03 4.03 0 0 0-3.269 1.678a.69.69 0 0 1-.555.283l-.104.002a4.02 4.02 0 0 0-3.917 4.02v.012a3.95 3.95 0 0 1-.642 2.16l-.003.004a4.02 4.02 0 0 0-.268 3.955a.63.63 0 0 1 0 .555a4 4 0 0 0-.395 1.715a3.917 3.917 0 0 0 3.923 3.923h10.461a3.917 3.917 0 0 0 3.923-3.923c0-.617-.148-1.197-.395-1.715a.63.63 0 0 1 0-.555M13.407 12.94h-.015l1.461 2.87c.15 3.417 1.484 0 4.74 0s4.677 3.803 4.827.387l1.385-3.897c-.066-1.518-1.165-1.624-1.385-1.624h-3.925a4.71 4.71 0 0 1-3.888-2.04a.321.321 0 0 0-.562.062l-.1.237a2.8 2.8 0 0 1-1.513 1.53q-.033.014-.062.024c-.288.15-.963.597-.988 1.754l.013.373z"
              clipRule="evenodd"
            ></path>
            <path
              fill="url(#f2931id9)"
              fillRule="evenodd"
              d="M28.352 16.197c.26-.53.395-1.122.395-1.74c0-.569-.117-1.103-.327-1.59h.006a4 4 0 0 0-.343-.626l-.002-.004a3.95 3.95 0 0 1-.642-2.159v-.012a4.02 4.02 0 0 0-4.021-4.022a.66.66 0 0 1-.555-.283a4.03 4.03 0 0 0-3.27-1.678a4.03 4.03 0 0 0-3.269 1.678a.69.69 0 0 1-.555.283l-.104.002a4.02 4.02 0 0 0-3.917 4.02v.012a3.95 3.95 0 0 1-.642 2.16l-.003.004a4.02 4.02 0 0 0-.268 3.955a.63.63 0 0 1 0 .555a4 4 0 0 0-.395 1.715a3.917 3.917 0 0 0 3.923 3.923h10.461a3.917 3.917 0 0 0 3.923-3.923c0-.617-.148-1.197-.395-1.715a.63.63 0 0 1 0-.555M13.407 12.94h-.015l1.461 2.87c.15 3.417 1.484 0 4.74 0s4.677 3.803 4.827.387l1.385-3.897c-.066-1.518-1.165-1.624-1.385-1.624h-3.925a4.71 4.71 0 0 1-3.888-2.04a.321.321 0 0 0-.562.062l-.1.237a2.8 2.8 0 0 1-1.513 1.53q-.033.014-.062.024c-.288.15-.963.597-.988 1.754l.013.373z"
              clipRule="evenodd"
            ></path>
            <path
              fill="url(#f2931ida)"
              fillRule="evenodd"
              d="M28.352 16.197c.26-.53.395-1.122.395-1.74c0-.569-.117-1.103-.327-1.59h.006a4 4 0 0 0-.343-.626l-.002-.004a3.95 3.95 0 0 1-.642-2.159v-.012a4.02 4.02 0 0 0-4.021-4.022a.66.66 0 0 1-.555-.283a4.03 4.03 0 0 0-3.27-1.678a4.03 4.03 0 0 0-3.269 1.678a.69.69 0 0 1-.555.283l-.104.002a4.02 4.02 0 0 0-3.917 4.02v.012a3.95 3.95 0 0 1-.642 2.16l-.003.004a4.02 4.02 0 0 0-.268 3.955a.63.63 0 0 1 0 .555a4 4 0 0 0-.395 1.715a3.917 3.917 0 0 0 3.923 3.923h10.461a3.917 3.917 0 0 0 3.923-3.923c0-.617-.148-1.197-.395-1.715a.63.63 0 0 1 0-.555M13.407 12.94h-.015l1.461 2.87c.15 3.417 1.484 0 4.74 0s4.677 3.803 4.827.387l1.385-3.897c-.066-1.518-1.165-1.624-1.385-1.624h-3.925a4.71 4.71 0 0 1-3.888-2.04a.321.321 0 0 0-.562.062l-.1.237a2.8 2.8 0 0 1-1.513 1.53q-.033.014-.062.024c-.288.15-.963.597-.988 1.754l.013.373z"
              clipRule="evenodd"
            ></path>
          </g>
          <path
            fill="url(#f2931idb)"
            d="M3.874 9.274c-.125-1.922-.282-2.959-.329-3.641c-.035-.512.024-1.066.711-1.191c.598-.075.883.451.907.66c-.003-.2 0-.68 0-.805c0-.21.007-.976.859-.976c.601 0 .816.587.8.863c.011-.102.023-.413.036-.707c.018-.434.251-.99.945-.977c.598.04.793.613.766.977l-.117 1.867c.023-.188.102-.665.277-1.34s.702-.72.957-.683c.326.046.88.36.649 1.273c-.276 1.156-.463 2.644-.528 3.285c.32-.13.605-.429.957-.796l.016-.016c.36-.375.933-.332 1.172-.106c.363.235.562.938.16 1.34c-.463.425-2.13 2.405-2.957 3.394c-.23.292-.997.875-2.235.875c-2.203-.093-2.941-1.676-3.046-3.296"
          ></path>
          <path
            fill="url(#f2931idc)"
            d="M3.874 9.274c-.125-1.922-.282-2.959-.329-3.641c-.035-.512.024-1.066.711-1.191c.598-.075.883.451.907.66c-.003-.2 0-.68 0-.805c0-.21.007-.976.859-.976c.601 0 .816.587.8.863c.011-.102.023-.413.036-.707c.018-.434.251-.99.945-.977c.598.04.793.613.766.977l-.117 1.867c.023-.188.102-.665.277-1.34s.702-.72.957-.683c.326.046.88.36.649 1.273c-.276 1.156-.463 2.644-.528 3.285c.32-.13.605-.429.957-.796l.016-.016c.36-.375.933-.332 1.172-.106c.363.235.562.938.16 1.34c-.463.425-2.13 2.405-2.957 3.394c-.23.292-.997.875-2.235.875c-2.203-.093-2.941-1.676-3.046-3.296"
          ></path>
          <path
            fill="url(#f2931id24)"
            d="M3.874 9.274c-.125-1.922-.282-2.959-.329-3.641c-.035-.512.024-1.066.711-1.191c.598-.075.883.451.907.66c-.003-.2 0-.68 0-.805c0-.21.007-.976.859-.976c.601 0 .816.587.8.863c.011-.102.023-.413.036-.707c.018-.434.251-.99.945-.977c.598.04.793.613.766.977l-.117 1.867c.023-.188.102-.665.277-1.34s.702-.72.957-.683c.326.046.88.36.649 1.273c-.276 1.156-.463 2.644-.528 3.285c.32-.13.605-.429.957-.796l.016-.016c.36-.375.933-.332 1.172-.106c.363.235.562.938.16 1.34c-.463.425-2.13 2.405-2.957 3.394c-.23.292-.997.875-2.235.875c-2.203-.093-2.941-1.676-3.046-3.296"
          ></path>
          <path
            fill="url(#f2931idd)"
            d="M3.874 9.274c-.125-1.922-.282-2.959-.329-3.641c-.035-.512.024-1.066.711-1.191c.598-.075.883.451.907.66c-.003-.2 0-.68 0-.805c0-.21.007-.976.859-.976c.601 0 .816.587.8.863c.011-.102.023-.413.036-.707c.018-.434.251-.99.945-.977c.598.04.793.613.766.977l-.117 1.867c.023-.188.102-.665.277-1.34s.702-.72.957-.683c.326.046.88.36.649 1.273c-.276 1.156-.463 2.644-.528 3.285c.32-.13.605-.429.957-.796l.016-.016c.36-.375.933-.332 1.172-.106c.363.235.562.938.16 1.34c-.463.425-2.13 2.405-2.957 3.394c-.23.292-.997.875-2.235.875c-2.203-.093-2.941-1.676-3.046-3.296"
          ></path>
          <path
            fill="url(#f2931ide)"
            d="M3.874 9.274c-.125-1.922-.282-2.959-.329-3.641c-.035-.512.024-1.066.711-1.191c.598-.075.883.451.907.66c-.003-.2 0-.68 0-.805c0-.21.007-.976.859-.976c.601 0 .816.587.8.863c.011-.102.023-.413.036-.707c.018-.434.251-.99.945-.977c.598.04.793.613.766.977l-.117 1.867c.023-.188.102-.665.277-1.34s.702-.72.957-.683c.326.046.88.36.649 1.273c-.276 1.156-.463 2.644-.528 3.285c.32-.13.605-.429.957-.796l.016-.016c.36-.375.933-.332 1.172-.106c.363.235.562.938.16 1.34c-.463.425-2.13 2.405-2.957 3.394c-.23.292-.997.875-2.235.875c-2.203-.093-2.941-1.676-3.046-3.296"
          ></path>
          <path
            fill="url(#f2931idf)"
            d="M3.874 9.274c-.125-1.922-.282-2.959-.329-3.641c-.035-.512.024-1.066.711-1.191c.598-.075.883.451.907.66c-.003-.2 0-.68 0-.805c0-.21.007-.976.859-.976c.601 0 .816.587.8.863c.011-.102.023-.413.036-.707c.018-.434.251-.99.945-.977c.598.04.793.613.766.977l-.117 1.867c.023-.188.102-.665.277-1.34s.702-.72.957-.683c.326.046.88.36.649 1.273c-.276 1.156-.463 2.644-.528 3.285c.32-.13.605-.429.957-.796l.016-.016c.36-.375.933-.332 1.172-.106c.363.235.562.938.16 1.34c-.463.425-2.13 2.405-2.957 3.394c-.23.292-.997.875-2.235.875c-2.203-.093-2.941-1.676-3.046-3.296"
          ></path>
          <path
            fill="url(#f2931idg)"
            d="M3.874 9.274c-.125-1.922-.282-2.959-.329-3.641c-.035-.512.024-1.066.711-1.191c.598-.075.883.451.907.66c-.003-.2 0-.68 0-.805c0-.21.007-.976.859-.976c.601 0 .816.587.8.863c.011-.102.023-.413.036-.707c.018-.434.251-.99.945-.977c.598.04.793.613.766.977l-.117 1.867c.023-.188.102-.665.277-1.34s.702-.72.957-.683c.326.046.88.36.649 1.273c-.276 1.156-.463 2.644-.528 3.285c.32-.13.605-.429.957-.796l.016-.016c.36-.375.933-.332 1.172-.106c.363.235.562.938.16 1.34c-.463.425-2.13 2.405-2.957 3.394c-.23.292-.997.875-2.235.875c-2.203-.093-2.941-1.676-3.046-3.296"
          ></path>
          <path
            fill="url(#f2931idh)"
            d="M3.874 9.274c-.125-1.922-.282-2.959-.329-3.641c-.035-.512.024-1.066.711-1.191c.598-.075.883.451.907.66c-.003-.2 0-.68 0-.805c0-.21.007-.976.859-.976c.601 0 .816.587.8.863c.011-.102.023-.413.036-.707c.018-.434.251-.99.945-.977c.598.04.793.613.766.977l-.117 1.867c.023-.188.102-.665.277-1.34s.702-.72.957-.683c.326.046.88.36.649 1.273c-.276 1.156-.463 2.644-.528 3.285c.32-.13.605-.429.957-.796l.016-.016c.36-.375.933-.332 1.172-.106c.363.235.562.938.16 1.34c-.463.425-2.13 2.405-2.957 3.394c-.23.292-.997.875-2.235.875c-2.203-.093-2.941-1.676-3.046-3.296"
          ></path>
          <path
            fill="url(#f2931idi)"
            d="M3.874 9.274c-.125-1.922-.282-2.959-.329-3.641c-.035-.512.024-1.066.711-1.191c.598-.075.883.451.907.66c-.003-.2 0-.68 0-.805c0-.21.007-.976.859-.976c.601 0 .816.587.8.863c.011-.102.023-.413.036-.707c.018-.434.251-.99.945-.977c.598.04.793.613.766.977l-.117 1.867c.023-.188.102-.665.277-1.34s.702-.72.957-.683c.326.046.88.36.649 1.273c-.276 1.156-.463 2.644-.528 3.285c.32-.13.605-.429.957-.796l.016-.016c.36-.375.933-.332 1.172-.106c.363.235.562.938.16 1.34c-.463.425-2.13 2.405-2.957 3.394c-.23.292-.997.875-2.235.875c-2.203-.093-2.941-1.676-3.046-3.296"
          ></path>
          <path
            fill="url(#f2931idj)"
            d="M3.874 9.274c-.125-1.922-.282-2.959-.329-3.641c-.035-.512.024-1.066.711-1.191c.598-.075.883.451.907.66c-.003-.2 0-.68 0-.805c0-.21.007-.976.859-.976c.601 0 .816.587.8.863c.011-.102.023-.413.036-.707c.018-.434.251-.99.945-.977c.598.04.793.613.766.977l-.117 1.867c.023-.188.102-.665.277-1.34s.702-.72.957-.683c.326.046.88.36.649 1.273c-.276 1.156-.463 2.644-.528 3.285c.32-.13.605-.429.957-.796l.016-.016c.36-.375.933-.332 1.172-.106c.363.235.562.938.16 1.34c-.463.425-2.13 2.405-2.957 3.394c-.23.292-.997.875-2.235.875c-2.203-.093-2.941-1.676-3.046-3.296"
          ></path>
          <path
            fill="url(#f2931idk)"
            d="M3.874 9.274c-.125-1.922-.282-2.959-.329-3.641c-.035-.512.024-1.066.711-1.191c.598-.075.883.451.907.66c-.003-.2 0-.68 0-.805c0-.21.007-.976.859-.976c.601 0 .816.587.8.863c.011-.102.023-.413.036-.707c.018-.434.251-.99.945-.977c.598.04.793.613.766.977l-.117 1.867c.023-.188.102-.665.277-1.34s.702-.72.957-.683c.326.046.88.36.649 1.273c-.276 1.156-.463 2.644-.528 3.285c.32-.13.605-.429.957-.796l.016-.016c.36-.375.933-.332 1.172-.106c.363.235.562.938.16 1.34c-.463.425-2.13 2.405-2.957 3.394c-.23.292-.997.875-2.235.875c-2.203-.093-2.941-1.676-3.046-3.296"
          ></path>
          <path
            fill="url(#f2931id25)"
            d="M4.944 12.203c0-.11.09-.2.2-.2h3.81a.2.2 0 0 1 .2.2v1.714h-4.21z"
          ></path>
          <path
            fill="url(#f2931idl)"
            d="M4.944 12.203c0-.11.09-.2.2-.2h3.81a.2.2 0 0 1 .2.2v1.714h-4.21z"
          ></path>
          <path
            fill="url(#f2931id26)"
            d="M4.944 12.203c0-.11.09-.2.2-.2h3.81a.2.2 0 0 1 .2.2v1.714h-4.21z"
          ></path>
          <path
            fill="url(#f2931id27)"
            d="M20.558 21.026h.97c2.49 0 7.472 3.5 7.472 9H11.067v-3.5a.67.67 0 0 0-.414-.625L7.58 24.526c-2.49-1-3.487-3.5-3.487-5.198v-5.287c0-.564.424-1.015.932-1.015H9.14c.518 0 .932.462.932 1.015v3.985c0 1.302.996 1.5.996 1.5l5.978 1.5z"
          ></path>
          <path
            fill="url(#f2931idm)"
            d="M20.558 21.026h.97c2.49 0 7.472 3.5 7.472 9H11.067v-3.5a.67.67 0 0 0-.414-.625L7.58 24.526c-2.49-1-3.487-3.5-3.487-5.198v-5.287c0-.564.424-1.015.932-1.015H9.14c.518 0 .932.462.932 1.015v3.985c0 1.302.996 1.5.996 1.5l5.978 1.5z"
          ></path>
          <path
            fill="url(#f2931idn)"
            d="M20.558 21.026h.97c2.49 0 7.472 3.5 7.472 9H11.067v-3.5a.67.67 0 0 0-.414-.625L7.58 24.526c-2.49-1-3.487-3.5-3.487-5.198v-5.287c0-.564.424-1.015.932-1.015H9.14c.518 0 .932.462.932 1.015v3.985c0 1.302.996 1.5.996 1.5l5.978 1.5z"
          ></path>
          <path
            fill="url(#f2931id28)"
            d="m18.951 21.136l-7.873 5.245a.66.66 0 0 0-.4-.48l-3.085-1.375c-2.5-1-3.5-3.5-3.5-5.198v-5.287c0-.564.425-1.015.936-1.015h4.129c.52 0 .935.462.935 1.015v3.985c0 1.302 1 1.5 1 1.5l6 1.5z"
          ></path>
          <path
            fill="url(#f2931ido)"
            d="m18.951 21.136l-7.873 5.245a.66.66 0 0 0-.4-.48l-3.085-1.375c-2.5-1-3.5-3.5-3.5-5.198v-5.287c0-.564.425-1.015.936-1.015h4.129c.52 0 .935.462.935 1.015v3.985c0 1.302 1 1.5 1 1.5l6 1.5z"
          ></path>
          <path
            fill="url(#f2931idp)"
            d="m18.951 21.136l-7.873 5.245a.66.66 0 0 0-.4-.48l-3.085-1.375c-2.5-1-3.5-3.5-3.5-5.198v-5.287c0-.564.425-1.015.936-1.015h4.129c.52 0 .935.462.935 1.015v3.985c0 1.302 1 1.5 1 1.5l6 1.5z"
          ></path>
          <path
            fill="url(#f2931idq)"
            d="m18.951 21.136l-7.873 5.245a.66.66 0 0 0-.4-.48l-3.085-1.375c-2.5-1-3.5-3.5-3.5-5.198v-5.287c0-.564.425-1.015.936-1.015h4.129c.52 0 .935.462.935 1.015v3.985c0 1.302 1 1.5 1 1.5l6 1.5z"
          ></path>
          <path
            fill="url(#f2931id29)"
            d="m18.951 21.136l-7.873 5.245a.66.66 0 0 0-.4-.48l-3.085-1.375c-2.5-1-3.5-3.5-3.5-5.198v-5.287c0-.564.425-1.015.936-1.015h4.129c.52 0 .935.462.935 1.015v3.985c0 1.302 1 1.5 1 1.5l6 1.5z"
          ></path>
          <path
            fill="url(#f2931id2a)"
            d="m18.951 21.136l-7.873 5.245a.66.66 0 0 0-.4-.48l-3.085-1.375c-2.5-1-3.5-3.5-3.5-5.198v-5.287c0-.564.425-1.015.936-1.015h4.129c.52 0 .935.462.935 1.015v3.985c0 1.302 1 1.5 1 1.5l6 1.5z"
          ></path>
          <path
            fill="url(#f2931id2b)"
            d="M19.593 24.132c-1.267 0-2.296-.985-2.296-2.2v-2.6c0-1.215 1.029-2.2 2.296-2.2c1.268 0 2.297.985 2.297 2.2v2.6c0 1.215-1.029 2.2-2.297 2.2"
          ></path>
          <path
            fill="url(#f2931idr)"
            d="M19.593 24.132c-1.267 0-2.296-.985-2.296-2.2v-2.6c0-1.215 1.029-2.2 2.296-2.2c1.268 0 2.297.985 2.297 2.2v2.6c0 1.215-1.029 2.2-2.297 2.2"
          ></path>
          <g filter="url(#f2931id1f)">
            <path
              stroke="url(#f2931id2c)"
              d="M7.936 13.954v5.172a2 2 0 0 0 1.38 1.901l4.182 1.363"
            ></path>
          </g>
          <g filter="url(#f2931id1g)">
            <path
              stroke="url(#f2931id2d)"
              strokeLinecap="round"
              strokeWidth=".075"
              d="m5.187 5.213l.132 1.42"
            ></path>
          </g>
          <g filter="url(#f2931id1h)">
            <path
              stroke="url(#f2931id2e)"
              strokeLinecap="round"
              strokeWidth=".075"
              d="m6.82 4.3l-.094 2.062"
            ></path>
          </g>
          <g filter="url(#f2931id1i)">
            <path
              stroke="url(#f2931id2f)"
              strokeLinecap="round"
              strokeWidth=".075"
              d="m8.429 5.432l-.156 1.203"
            ></path>
          </g>
          <g filter="url(#f2931id1j)">
            <path
              fill="url(#f2931id2g)"
              d="M13.882 16.44a1.962 1.962 0 1 0 0-3.923a1.962 1.962 0 0 0 0 3.923"
            ></path>
          </g>
          <g filter="url(#f2931id1k)">
            <path
              fill="url(#f2931ids)"
              d="M25.478 16.44a1.962 1.962 0 1 0 0-3.923a1.962 1.962 0 0 0 0 3.923"
            ></path>
          </g>
          <g filter="url(#f2931id1l)">
            <path
              fill="#FFCA38"
              d="M25.478 15.788a1.31 1.31 0 1 0 0-2.619a1.31 1.31 0 0 0 0 2.62"
            ></path>
            <path
              fill="url(#f2931idt)"
              d="M25.478 15.788a1.31 1.31 0 1 0 0-2.619a1.31 1.31 0 0 0 0 2.62"
            ></path>
          </g>
          <g filter="url(#f2931id1m)">
            <path
              fill="#E28527"
              d="M13.905 15.788a1.31 1.31 0 1 0 0-2.619a1.31 1.31 0 0 0 0 2.62"
            ></path>
            <path
              fill="url(#f2931idu)"
              d="M13.905 15.788a1.31 1.31 0 1 0 0-2.619a1.31 1.31 0 0 0 0 2.62"
            ></path>
          </g>
          <g filter="url(#f2931id1n)">
            <path
              fill="url(#f2931idv)"
              d="M13.392 12.94h.015l-.012-.324l-.013-.373c.025-1.157.7-1.604.988-1.754l.062-.025l.063-.024a2.8 2.8 0 0 0 1.45-1.505l.1-.237a.321.321 0 0 1 .562-.062a4.71 4.71 0 0 0 3.888 2.04h3.925c.22 0 1.32.106 1.385 1.624l-.145 3.746c-.15 3.416-2.818 5.71-6.075 5.71c-3.256 0-5.924-2.294-6.074-5.71z"
            ></path>
            <path
              fill="url(#f2931idw)"
              d="M13.392 12.94h.015l-.012-.324l-.013-.373c.025-1.157.7-1.604.988-1.754l.062-.025l.063-.024a2.8 2.8 0 0 0 1.45-1.505l.1-.237a.321.321 0 0 1 .562-.062a4.71 4.71 0 0 0 3.888 2.04h3.925c.22 0 1.32.106 1.385 1.624l-.145 3.746c-.15 3.416-2.818 5.71-6.075 5.71c-3.256 0-5.924-2.294-6.074-5.71z"
            ></path>
            <path
              fill="url(#f2931idx)"
              d="M13.392 12.94h.015l-.012-.324l-.013-.373c.025-1.157.7-1.604.988-1.754l.062-.025l.063-.024a2.8 2.8 0 0 0 1.45-1.505l.1-.237a.321.321 0 0 1 .562-.062a4.71 4.71 0 0 0 3.888 2.04h3.925c.22 0 1.32.106 1.385 1.624l-.145 3.746c-.15 3.416-2.818 5.71-6.075 5.71c-3.256 0-5.924-2.294-6.074-5.71z"
            ></path>
            <path
              fill="url(#f2931idy)"
              d="M13.392 12.94h.015l-.012-.324l-.013-.373c.025-1.157.7-1.604.988-1.754l.062-.025l.063-.024a2.8 2.8 0 0 0 1.45-1.505l.1-.237a.321.321 0 0 1 .562-.062a4.71 4.71 0 0 0 3.888 2.04h3.925c.22 0 1.32.106 1.385 1.624l-.145 3.746c-.15 3.416-2.818 5.71-6.075 5.71c-3.256 0-5.924-2.294-6.074-5.71z"
            ></path>
            <path
              fill="url(#f2931idz)"
              d="M13.392 12.94h.015l-.012-.324l-.013-.373c.025-1.157.7-1.604.988-1.754l.062-.025l.063-.024a2.8 2.8 0 0 0 1.45-1.505l.1-.237a.321.321 0 0 1 .562-.062a4.71 4.71 0 0 0 3.888 2.04h3.925c.22 0 1.32.106 1.385 1.624l-.145 3.746c-.15 3.416-2.818 5.71-6.075 5.71c-3.256 0-5.924-2.294-6.074-5.71z"
            ></path>
            <path
              fill="url(#f2931id10)"
              d="M13.392 12.94h.015l-.012-.324l-.013-.373c.025-1.157.7-1.604.988-1.754l.062-.025l.063-.024a2.8 2.8 0 0 0 1.45-1.505l.1-.237a.321.321 0 0 1 .562-.062a4.71 4.71 0 0 0 3.888 2.04h3.925c.22 0 1.32.106 1.385 1.624l-.145 3.746c-.15 3.416-2.818 5.71-6.075 5.71c-3.256 0-5.924-2.294-6.074-5.71z"
            ></path>
            <path
              fill="url(#f2931id11)"
              d="M13.392 12.94h.015l-.012-.324l-.013-.373c.025-1.157.7-1.604.988-1.754l.062-.025l.063-.024a2.8 2.8 0 0 0 1.45-1.505l.1-.237a.321.321 0 0 1 .562-.062a4.71 4.71 0 0 0 3.888 2.04h3.925c.22 0 1.32.106 1.385 1.624l-.145 3.746c-.15 3.416-2.818 5.71-6.075 5.71c-3.256 0-5.924-2.294-6.074-5.71z"
            ></path>
          </g>
          <path
            fill="url(#f2931id12)"
            d="M13.392 12.94h.015l-.012-.324l-.013-.373c.025-1.157.7-1.604.988-1.754l.062-.025l.063-.024a2.8 2.8 0 0 0 1.45-1.505l.1-.237a.321.321 0 0 1 .562-.062a4.71 4.71 0 0 0 3.888 2.04h3.925c.22 0 1.32.106 1.385 1.624l-.145 3.746c-.15 3.416-2.818 5.71-6.075 5.71c-3.256 0-5.924-2.294-6.074-5.71z"
          ></path>
          <g filter="url(#f2931id1o)">
            <path
              fill="#EB8B29"
              d="m19.115 14.207l-.833 2.072a.657.657 0 0 0 .634.853h.959a.66.66 0 0 0 .634-.853l-.648-2.072c-.138-.459-.6-.459-.746 0"
            ></path>
          </g>
          <g filter="url(#f2931id1p)">
            <path
              fill="url(#f2931id2h)"
              d="m19.127 14.038l-.647 2.073a.657.657 0 0 0 .634.852h.959a.66.66 0 0 0 .634-.852l-.648-2.073c-.138-.459-.786-.459-.932 0"
            ></path>
            <path
              fill="url(#f2931id13)"
              d="m19.127 14.038l-.647 2.073a.657.657 0 0 0 .634.852h.959a.66.66 0 0 0 .634-.852l-.648-2.073c-.138-.459-.786-.459-.932 0"
            ></path>
            <path
              fill="url(#f2931id2i)"
              d="m19.127 14.038l-.647 2.073a.657.657 0 0 0 .634.852h.959a.66.66 0 0 0 .634-.852l-.648-2.073c-.138-.459-.786-.459-.932 0"
            ></path>
            <path
              fill="url(#f2931id2j)"
              d="m19.127 14.038l-.647 2.073a.657.657 0 0 0 .634.852h.959a.66.66 0 0 0 .634-.852l-.648-2.073c-.138-.459-.786-.459-.932 0"
            ></path>
          </g>
          <path
            fill="url(#f2931id2k)"
            d="m19.127 14.038l-.647 2.073a.657.657 0 0 0 .634.852h.959a.66.66 0 0 0 .634-.852l-.648-2.073c-.138-.459-.786-.459-.932 0"
          ></path>
          <path
            fill="url(#f2931id14)"
            d="m19.127 14.038l-.647 2.073a.657.657 0 0 0 .634.852h.959a.66.66 0 0 0 .634-.852l-.648-2.073c-.138-.459-.786-.459-.932 0"
          ></path>
          <path
            fill="#8A004F"
            stroke="url(#f2931id2l)"
            strokeWidth=".1"
            d="M17.884 17.564a3.64 3.64 0 0 0 1.71.414c.633 0 1.215-.151 1.709-.414a.24.24 0 0 1 .288.048a.23.23 0 0 1 .025.29m-3.732-.338l3.69.311m-3.69-.311a.24.24 0 0 0-.289.05a.23.23 0 0 0-.024.289m.313-.34l-.271.312m4.003.027l-.042-.027m.042.027l-.042-.027m.042.027a2.405 2.405 0 0 1-4.045 0m4.003-.027a2.355 2.355 0 0 1-3.961 0m-.042.028l.042-.028m-.042.028l.042-.028"
          ></path>
          <g filter="url(#f2931id1q)">
            <path
              fill="#635D5F"
              d="M20.986 13.785c.323-.569.815-1.018 1.874-1.018c.463 0 .91.128 1.308.449c.327.265.283.604.03.73l-.678.388c-.795-.257-1.674-.292-2.534-.549"
            ></path>
          </g>
          <g filter="url(#f2931id1r)">
            <path
              fill="#635D5F"
              d="M18.202 13.785c-.324-.569-.816-1.018-1.875-1.018c-.463 0-.91.128-1.307.449c-.328.265-.284.604-.03.73l.678.388c.794-.257 1.673-.292 2.534-.549"
            ></path>
          </g>
          <g filter="url(#f2931id1s)">
            <path
              fill="#BD4F26"
              d="m15.452 12.312l-.006.003a.327.327 0 0 1-.336-.561l.002-.001l.004-.002l.011-.007a2 2 0 0 1 .181-.094c.12-.057.291-.13.5-.197c.414-.132.994-.243 1.62-.133a.327.327 0 0 1-.114.644c-.486-.086-.953-.001-1.307.112a3.4 3.4 0 0 0-.555.236"
            ></path>
          </g>
          <g filter="url(#f2931id1t)">
            <path
              fill="#BD4F26"
              fillRule="evenodd"
              d="m24.142 11.754l-.168.28za.327.327 0 0 1-.335.56h-.001l-.005-.002a2 2 0 0 0-.138-.072a3 3 0 0 0-.418-.164c-.354-.113-.82-.198-1.306-.112a.327.327 0 0 1-.114-.644c.626-.11 1.205 0 1.62.133a4 4 0 0 1 .68.29l.012.008l.003.002z"
              clipRule="evenodd"
            ></path>
          </g>
          <path
            fill="#fff"
            d="M22.508 12.838c.796 0 1.469.549 1.652 1.29a.334.334 0 0 1-.327.416h-2.72a.28.28 0 0 1-.276-.331a1.704 1.704 0 0 1 1.671-1.375"
          ></path>
          <path
            fill="url(#f2931id15)"
            d="M22.256 13.17a1.088 1.088 0 0 1 1.048 1.374h-2.101a1.092 1.092 0 0 1 1.053-1.375"
          ></path>
          <path
            fill="#000"
            d="M21.633 14.257a.62.62 0 0 1 .623-.623a.62.62 0 0 1 .554.91h-1.103a.56.56 0 0 1-.074-.287"
          ></path>
          <g filter="url(#f2931id1u)">
            <path
              fill="#C7A7A3"
              d="M22.175 13.4c.078.103-.084.23-.268.367c-.184.138-.32.235-.398.131s.009-.3.193-.437s.396-.165.473-.061"
            ></path>
            <path
              fill="url(#f2931id16)"
              d="M22.175 13.4c.078.103-.084.23-.268.367c-.184.138-.32.235-.398.131s.009-.3.193-.437s.396-.165.473-.061"
            ></path>
          </g>
          <g filter="url(#f2931id1v)">
            <path
              fill="url(#f2931id2m)"
              d="M23.224 14.114a1.02 1.02 0 0 0-.282-.564l-.316.347l.143.278z"
            ></path>
          </g>
          <path
            fill="#fff"
            d="M16.679 12.838c-.796 0-1.469.549-1.652 1.29a.334.334 0 0 0 .327.416h2.72a.28.28 0 0 0 .276-.331a1.71 1.71 0 0 0-1.671-1.375"
          ></path>
          <path
            fill="url(#f2931id17)"
            d="M16.93 13.17a1.088 1.088 0 0 0-1.047 1.374h2.101q.039-.14.04-.287a1.095 1.095 0 0 0-1.093-1.088"
          ></path>
          <path
            fill="#000"
            d="M17.554 14.257a.62.62 0 0 0-.623-.623a.62.62 0 0 0-.554.91h1.103a.6.6 0 0 0 .074-.287"
          ></path>
          <g filter="url(#f2931id1w)">
            <path
              fill="url(#f2931id2n)"
              d="M17.924 14.129c0-.351-.285-.585-.363-.656l-.35.34l.215.44z"
            ></path>
          </g>
          <g filter="url(#f2931id1x)">
            <ellipse
              cx="16.602"
              cy="13.634"
              fill="#C7A7A3"
              fillOpacity=".9"
              rx=".475"
              ry=".24"
              transform="rotate(-27.914 16.602 13.634)"
            ></ellipse>
            <ellipse
              cx="16.602"
              cy="13.634"
              fill="url(#f2931id18)"
              rx=".475"
              ry=".24"
              transform="rotate(-27.914 16.602 13.634)"
            ></ellipse>
          </g>
          <g filter="url(#f2931id1y)">
            <path
              stroke="#C9725D"
              strokeLinecap="round"
              strokeWidth=".4"
              d="M21.958 11.586c.393-.095 1.37-.047 2.024.42"
            ></path>
          </g>
          <g filter="url(#f2931id1z)">
            <path
              stroke="#C9725D"
              strokeLinecap="round"
              strokeWidth=".4"
              d="M17.337 11.586c-.393-.095-1.371-.047-2.025.42"
            ></path>
          </g>
          <g filter="url(#f2931id20)">
            <path
              fill="url(#f2931id19)"
              d="M13.627 7.148c.757-.675 1.85-.681 2.462-.572l.49 1.573c-.313-.048-.592.061-.827.286c-.556 1.536-2.465 2.384-3.35 2.615c-.184-1.818-.082-2.738 1.225-3.902"
            ></path>
            <path
              fill="url(#f2931id1a)"
              d="M13.627 7.148c.757-.675 1.85-.681 2.462-.572l.49 1.573c-.313-.048-.592.061-.827.286c-.556 1.536-2.465 2.384-3.35 2.615c-.184-1.818-.082-2.738 1.225-3.902"
            ></path>
          </g>
          <g filter="url(#f2931id21)">
            <path
              fill="url(#f2931id1b)"
              d="M18.858 4.982c-1.38-.305-2.86 1.165-3.004 1.675c1.88 4.414 4.767 3.993 7.969 3.637c1.917-.213 2.125.66 2.288 1.083c-.53-4.944-4.107-5.7-7.253-6.395"
            ></path>
            <path
              fill="url(#f2931id1c)"
              d="M18.858 4.982c-1.38-.305-2.86 1.165-3.004 1.675c1.88 4.414 4.767 3.993 7.969 3.637c1.917-.213 2.125.66 2.288 1.083c-.53-4.944-4.107-5.7-7.253-6.395"
            ></path>
            <path
              fill="url(#f2931id1d)"
              d="M18.858 4.982c-1.38-.305-2.86 1.165-3.004 1.675c1.88 4.414 4.767 3.993 7.969 3.637c1.917-.213 2.125.66 2.288 1.083c-.53-4.944-4.107-5.7-7.253-6.395"
            ></path>
          </g>
          <g filter="url(#f2931id22)">
            <path
              stroke="url(#f2931id2o)"
              strokeLinecap="round"
              strokeWidth=".1"
              d="M16.069 6.504c.028.296.286 1.41.664 2.084"
            ></path>
          </g>
          <defs>
            <radialGradient
              id="f2931id0"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(3.42333 1.84334 -2.611 4.84898 24.254 18.5)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".616" stopColor="#E38923"></stop>
              <stop offset="1" stopColor="#E38923" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id1"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 5.43242 -3.27286 0 14.021 16.958)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#C9641B"></stop>
              <stop offset="1" stopColor="#D77117" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id2"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 6.79105 -7.07411 0 19.593 17.07)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".617" stopColor="#E26B25"></stop>
              <stop offset="1" stopColor="#E26B25" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id3"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-1.51247 1.96278 -1.90576 -1.46853 13.607 14.87)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".161" stopColor="#C9681C"></stop>
              <stop offset="1" stopColor="#C9681C" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id4"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.56998 3.0643 -3.19089 -.59353 14.328 11.9)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".365" stopColor="#D76A18"></stop>
              <stop offset="1" stopColor="#D76A18" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id5"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(1.33548 2.5769 -4.90894 2.54406 15.526 5.747)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".222" stopColor="#CBA140"></stop>
              <stop offset=".921" stopColor="#CBA140" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id6"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(132.51 11.504 9.521)scale(1.99566 2.7889)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFDF3C"></stop>
              <stop offset="1" stopColor="#FFDF3C" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id7"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-2.24742 .65383 -1.42265 -4.8901 28.747 13.44)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFD537"></stop>
              <stop offset="1" stopColor="#FFD336" stopOpacity="0"></stop>
              <stop offset="1" stopColor="#FFD537" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id8"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(-133.315 18.175 5.749)scale(5.68317 8.16169)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#CB6325"></stop>
              <stop offset="1" stopColor="#CB6325" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id9"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.0103 -1.67535 .54929 -.00337 16.296 8.788)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".295" stopColor="#DB6009"></stop>
              <stop offset="1" stopColor="#DB6009" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931ida"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(-134.119 13.937 7.098)scale(10.1929 9.02205)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".28" stopColor="#803706"></stop>
              <stop offset="1" stopColor="#D96D24" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idb"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(2.33335 -6.04232 7.22855 2.79144 6.453 11.91)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".475" stopColor="#F4B937"></stop>
              <stop offset="1" stopColor="#F2B830"></stop>
              <stop offset="1" stopColor="#EEB32A"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idc"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(130.764 3.062 7.467)scale(9.5721 2.30417)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".147" stopColor="#D27C28"></stop>
              <stop offset="1" stopColor="#E9AA33" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idd"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(.19531 2.2578 -.27074 .02342 5.178 5.097)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".415" stopColor="#E5A70F"></stop>
              <stop offset="1" stopColor="#EAAA15" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931ide"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.04685 3.40625 -.266 -.00366 6.827 3.932)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".401" stopColor="#EAAA15"></stop>
              <stop offset="1" stopColor="#EAAA15" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idf"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.67188 3.96875 -.56716 -.09602 8.795 3.167)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".652" stopColor="#EAAA15"></stop>
              <stop offset="1" stopColor="#EAAA15" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idg"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.89063 .84376 -.848 -.8951 10.14 3.714)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFDC45"></stop>
              <stop offset="1" stopColor="#FFDC45" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idh"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(138.965 3.67 2.974)scale(1.11858 .93215)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFDC45"></stop>
              <stop offset="1" stopColor="#FFDC45" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idi"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.46875 .71876 -.65233 -.42542 6.266 3.37)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFDC45"></stop>
              <stop offset="1" stopColor="#FFDC45" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idj"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.5 .60938 -.55306 -.45379 4.686 4.651)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFDC45"></stop>
              <stop offset="1" stopColor="#FFDC45" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idk"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(85.723 -.471 5.152)scale(2.30438 .44699)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFCC3D"></stop>
              <stop offset="1" stopColor="#FFCC3D" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idl"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 1.10937 -1.15625 0 7.71 12.479)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#6E5098"></stop>
              <stop offset="1" stopColor="#6E5098" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idm"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-8.68288 2.79847 -2.9931 -9.28678 26.68 27.228)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#A47FF0"></stop>
              <stop offset="1" stopColor="#A47FF0" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idn"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 -4.62502 2.65624 0 11.47 30.026)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#9473D7"></stop>
              <stop offset="1" stopColor="#9473D7" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931ido"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 8.8125 -5.4375 0 3.56 13.026)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#8F75C7"></stop>
              <stop offset="1" stopColor="#8F75C7" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idp"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(-167.876 10.227 9.245)scale(10.3399 4.20474)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".287" stopColor="#522A56"></stop>
              <stop offset="1" stopColor="#7952B0" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idq"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-5.69115 0 0 -5.7286 12.33 15.939)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".132" stopColor="#522A56"></stop>
              <stop offset="1" stopColor="#7952B0" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idr"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 1.15625 -2.61254 0 19.593 21.32)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#E97E36"></stop>
              <stop offset="1" stopColor="#E97E36" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931ids"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(-24.444 46.916 -49.087)scale(3.3329 4.06932)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".572" stopColor="#FFC531"></stop>
              <stop offset=".905" stopColor="#FFE549"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idt"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(-20.298 53.848 -62.982)scale(1.59029)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".71" stopColor="#FFBA25" stopOpacity="0"></stop>
              <stop offset="1" stopColor="#FFBA25"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idu"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-1.30934 0 0 -1.25247 13.905 14.479)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".415" stopColor="#D67923" stopOpacity="0"></stop>
              <stop offset="1" stopColor="#D67923"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idv"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(155.244 10.023 9.444)scale(8.73018 11.6852)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFE644"></stop>
              <stop offset="1" stopColor="#EB9235"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idw"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-2.57177 1.3603 -1.15412 -2.18196 21.91 14.674)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFE842"></stop>
              <stop offset="1" stopColor="#FFE842" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idx"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(-78.311 22.033 .646)scale(5.03546 6.38906)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#E4883F"></stop>
              <stop offset="1" stopColor="#E4883F" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idy"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 9.07009 -14.4058 0 19.274 13.234)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".593" stopColor="#F3943B" stopOpacity="0"></stop>
              <stop offset="1" stopColor="#D97C39"></stop>
            </radialGradient>
            <radialGradient
              id="f2931idz"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-6.6101 1.82793 -3.14713 -11.38057 20.358 15.843)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".877" stopColor="#D4993E" stopOpacity="0"></stop>
              <stop offset="1" stopColor="#D4993E"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id10"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 -1.40279 1.72161 0 22.399 13.313)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFBB31"></stop>
              <stop offset="1" stopColor="#FFBB31" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id11"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 -1.65784 1.9 0 17.255 13.42)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#F09429"></stop>
              <stop offset="1" stopColor="#F09429" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id12"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-1.64194 0 0 -5.40531 25.805 15.127)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFDA39"></stop>
              <stop offset="1" stopColor="#FFDA39" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id13"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.8502 -2.98624 1.70876 -.4865 20.55 16.013)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".017" stopColor="#FFE848"></stop>
              <stop offset="1" stopColor="#FFE848" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id14"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(144.462 7.476 10.984)scale(1.91979 2.57142)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".797" stopColor="#E2802F" stopOpacity="0"></stop>
              <stop offset="1" stopColor="#E2802F"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id15"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 .989 -1.57311 0 22.253 13.75)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".802" stopColor="#925C51"></stop>
              <stop offset="1" stopColor="#694B43"></stop>
              <stop offset="1" stopColor="#804D49"></stop>
              <stop offset="1" stopColor="#85534D"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id16"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.28248 -.36401 .50116 -.3889 21.975 13.853)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".766" stopColor="#FFE6E2" stopOpacity="0"></stop>
              <stop offset=".966" stopColor="#FFE6E2"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id17"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(0 .989 -1.57312 0 16.933 13.75)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".802" stopColor="#925C51"></stop>
              <stop offset="1" stopColor="#694B43"></stop>
              <stop offset="1" stopColor="#804D49"></stop>
              <stop offset="1" stopColor="#85534D"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id18"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-.00942 -.60178 .72335 -.01133 16.584 14.018)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".766" stopColor="#FFE6E2" stopOpacity="0"></stop>
              <stop offset=".966" stopColor="#FFE6E2"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id19"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-4.16817 5.0467 -2.20102 -1.81787 16.284 6.004)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".396" stopColor="#EE971B" stopOpacity="0"></stop>
              <stop offset=".911" stopColor="#D8772C"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id1a"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-3.78228 2.70206 -1.3354 -1.86926 16.113 6.67)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".12" stopColor="#FFCA2D"></stop>
              <stop offset="1" stopColor="#FFE134" stopOpacity="0"></stop>
              <stop offset="1" stopColor="#FFCA2D" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id1b"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-2.66394 5.5526 -7.88377 -3.78235 21.777 4.574)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".627" stopColor="#F49523" stopOpacity="0"></stop>
              <stop offset="1" stopColor="#F49523"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id1c"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="rotate(105.909 9.023 11.6)scale(4.19341 8.78806)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".132" stopColor="#FFE337"></stop>
              <stop offset="1" stopColor="#FFE337" stopOpacity="0"></stop>
            </radialGradient>
            <radialGradient
              id="f2931id1d"
              cx="0"
              cy="0"
              r="1"
              gradientTransform="matrix(-4.16511 -7.88382 7.04765 -3.72335 20.995 12.967)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".898" stopColor="#CA9B37" stopOpacity="0"></stop>
              <stop offset="1" stopColor="#CA9B37"></stop>
            </radialGradient>
            <filter
              id="f2931id1e"
              width="18.557"
              height="18.557"
              x="10.44"
              y="3.833"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dx=".25" dy="-.25"></feOffset>
              <feGaussianBlur stdDeviation=".375"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 0.92549 0 0 0 0 0.537255 0 0 0 0 0.12549 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect1_innerShadow_4002_3860"
              ></feBlend>
            </filter>
            <filter
              id="f2931id1f"
              width="9.217"
              height="11.911"
              x="5.936"
              y="12.454"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3860"
                stdDeviation=".75"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f2931id1g"
              width=".407"
              height="1.694"
              x="5.049"
              y="5.076"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3860"
                stdDeviation=".05"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f2931id1h"
              width=".369"
              height="2.337"
              x="6.588"
              y="4.162"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3860"
                stdDeviation=".05"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f2931id1i"
              width=".431"
              height="1.478"
              x="8.135"
              y="5.295"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3860"
                stdDeviation=".05"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f2931id1j"
              width="4.023"
              height="3.923"
              x="11.92"
              y="12.517"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dx=".1"></feOffset>
              <feGaussianBlur stdDeviation=".15"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 0.768627 0 0 0 0 0.501961 0 0 0 0 0.160784 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect1_innerShadow_4002_3860"
              ></feBlend>
            </filter>
            <filter
              id="f2931id1k"
              width="3.923"
              height="4.173"
              x="23.516"
              y="12.267"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dy="-.25"></feOffset>
              <feGaussianBlur stdDeviation=".25"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 0.937255 0 0 0 0 0.576471 0 0 0 0 0.341176 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect1_innerShadow_4002_3860"
              ></feBlend>
            </filter>
            <filter
              id="f2931id1l"
              width="3.619"
              height="3.619"
              x="23.669"
              y="12.669"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3860"
                stdDeviation=".25"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f2931id1m"
              width="3.119"
              height="3.119"
              x="12.346"
              y="12.919"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3860"
                stdDeviation=".125"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f2931id1n"
              width="12.423"
              height="13.659"
              x="13.382"
              y="8.497"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dy=".4"></feOffset>
              <feGaussianBlur stdDeviation=".3"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 0.92549 0 0 0 0 0.529412 0 0 0 0 0.137255 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect1_innerShadow_4002_3860"
              ></feBlend>
            </filter>
            <filter
              id="f2931id1o"
              width="3.288"
              height="4.269"
              x="17.751"
              y="13.363"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3860"
                stdDeviation=".25"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f2931id1p"
              width="2.788"
              height="3.769"
              x="18.199"
              y="13.444"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3860"
                stdDeviation=".125"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f2931id1q"
              width="3.615"
              height="1.567"
              x="20.786"
              y="12.767"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dx="-.2"></feOffset>
              <feGaussianBlur stdDeviation=".2"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 0.141176 0 0 0 0 0.0862745 0 0 0 0 0.176471 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect1_innerShadow_4002_3860"
              ></feBlend>
            </filter>
            <filter
              id="f2931id1r"
              width="3.615"
              height="1.567"
              x="14.787"
              y="12.767"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dx=".2"></feOffset>
              <feGaussianBlur stdDeviation=".125"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 0.133333 0 0 0 0 0.0784314 0 0 0 0 0.168627 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect1_innerShadow_4002_3860"
              ></feBlend>
            </filter>
            <filter
              id="f2931id1s"
              width="2.946"
              height="1.286"
              x="14.951"
              y="11.075"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dx=".2" dy="-.2"></feOffset>
              <feGaussianBlur stdDeviation=".15"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 0.658824 0 0 0 0 0.270588 0 0 0 0 0.141176 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect1_innerShadow_4002_3860"
              ></feBlend>
            </filter>
            <filter
              id="f2931id1t"
              width="2.946"
              height="1.286"
              x="21.555"
              y="11.075"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dx=".2" dy="-.2"></feOffset>
              <feGaussianBlur stdDeviation=".15"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 0.658824 0 0 0 0 0.270588 0 0 0 0 0.141176 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect1_innerShadow_4002_3860"
              ></feBlend>
            </filter>
            <filter
              id="f2931id1u"
              width=".915"
              height=".805"
              x="21.38"
              y="13.237"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3860"
                stdDeviation=".05"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f2931id1v"
              width=".998"
              height="1.025"
              x="22.426"
              y="13.35"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3860"
                stdDeviation=".1"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f2931id1w"
              width="1.114"
              height="1.18"
              x="17.01"
              y="13.273"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3860"
                stdDeviation=".1"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f2931id1x"
              width="1.069"
              height=".814"
              x="16.068"
              y="13.227"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3860"
                stdDeviation=".05"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f2931id1y"
              width="3.225"
              height="1.66"
              x="21.358"
              y="10.946"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3860"
                stdDeviation=".2"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f2931id1z"
              width="3.225"
              height="1.66"
              x="14.712"
              y="10.946"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3860"
                stdDeviation=".2"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f2931id20"
              width="5.749"
              height="6.027"
              x="11.581"
              y="5.773"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3860"
                stdDeviation=".375"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f2931id21"
              width="11.257"
              height="7.436"
              x="15.354"
              y="4.441"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3860"
                stdDeviation=".25"
              ></feGaussianBlur>
            </filter>
            <filter
              id="f2931id22"
              width="1.264"
              height="2.684"
              x="15.769"
              y="6.204"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_4002_3860"
                stdDeviation=".125"
              ></feGaussianBlur>
            </filter>
            <linearGradient
              id="f2931id23"
              x1="25.315"
              x2="16.487"
              y1="6.004"
              y2="22.39"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFD93C"></stop>
              <stop offset="1" stopColor="#E37923"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id24"
              x1="6.936"
              x2="6.936"
              y1="12.57"
              y2="10.867"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#C77505"></stop>
              <stop offset="1" stopColor="#EFB234" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id25"
              x1="4.78"
              x2="9.155"
              y1="12.589"
              y2="12.589"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#77639C"></stop>
              <stop offset=".743" stopColor="#5F3B73"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id26"
              x1="7.049"
              x2="7.049"
              y1="12.003"
              y2="12.261"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#674A85"></stop>
              <stop offset="1" stopColor="#674A85" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id27"
              x1="13.978"
              x2="6.04"
              y1="24.513"
              y2="13.026"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#8F63E1"></stop>
              <stop offset="1" stopColor="#855FCF"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id28"
              x1="10.046"
              x2="12.002"
              y1="26.694"
              y2="20.41"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".1" stopColor="#8751E0"></stop>
              <stop offset="1" stopColor="#8751E0" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id29"
              x1="14.315"
              x2="13.576"
              y1="24.719"
              y2="23.323"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".213" stopColor="#8F63E1"></stop>
              <stop offset=".732" stopColor="#8F63E1" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id2a"
              x1="7.575"
              x2="7.575"
              y1="13.026"
              y2="14.066"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#7354A3"></stop>
              <stop offset="1" stopColor="#7354A3" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id2b"
              x1="17.904"
              x2="19.904"
              y1="20.757"
              y2="24.132"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#D16C15"></stop>
              <stop offset="1" stopColor="#FFC436"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id2c"
              x1="7.592"
              x2="13.342"
              y1="14.734"
              y2="23.015"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#9D74E7"></stop>
              <stop offset="1" stopColor="#9D74E7" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id2d"
              x1="5.187"
              x2="5.339"
              y1="5.213"
              y2="6.729"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#BB7401"></stop>
              <stop offset="1" stopColor="#EDAD18"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id2e"
              x1="6.773"
              x2="7.256"
              y1="4.424"
              y2="6.536"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#BB7401"></stop>
              <stop offset="1" stopColor="#EDAD18"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id2f"
              x1="8.351"
              x2="8.454"
              y1="5.505"
              y2="6.793"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#BB7401"></stop>
              <stop offset="1" stopColor="#EDAD18"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id2g"
              x1="11.92"
              x2="15.528"
              y1="14.585"
              y2="14.585"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#E79B27"></stop>
              <stop offset="1" stopColor="#B96201"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id2h"
              x1="19.593"
              x2="19.593"
              y1="16.963"
              y2="13.694"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFC134"></stop>
              <stop offset="1" stopColor="#F8C73F"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id2i"
              x1="18.318"
              x2="19.359"
              y1="16.034"
              y2="16.162"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#F8A322"></stop>
              <stop offset="1" stopColor="#F8A322" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id2j"
              x1="19.593"
              x2="19.593"
              y1="17.075"
              y2="16.331"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#E48538"></stop>
              <stop offset="1" stopColor="#E48538" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id2k"
              x1="19.689"
              x2="19.689"
              y1="17.044"
              y2="16.873"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#E2802F"></stop>
              <stop offset="1" stopColor="#E2802F" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id2l"
              x1="18.705"
              x2="19.256"
              y1="18.876"
              y2="17.813"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FEAC35"></stop>
              <stop offset="1" stopColor="#FEAC35" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id2m"
              x1="23.201"
              x2="22.819"
              y1="13.816"
              y2="14.052"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#B4948D"></stop>
              <stop offset="1" stopColor="#B4948D" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id2n"
              x1="17.84"
              x2="17.457"
              y1="13.816"
              y2="14.052"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#B4948D"></stop>
              <stop offset="1" stopColor="#B4948D" stopOpacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="f2931id2o"
              x1="16.069"
              x2="16.733"
              y1="6.923"
              y2="8.476"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FAA719"></stop>
              <stop offset="1" stopColor="#DB6008"></stop>
            </linearGradient>
          </defs>
        </g>
      </svg>
    );
  };